{
    "$defs": {
        "AdditionalMetric": {
            "additionalProperties": true,
            "properties": {
                "baseDimensionName": {
                    "description": "Name of the base dimension/column this metric aggregates",
                    "type": "string"
                },
                "baseMetricId": {
                    "$ref": "#/$defs/FieldId",
                    "description": "For PoP-generated metrics, the base metric id that this metric is derived from."
                },
                "baseMetricName": {
                    "description": "Name of the explore metric this metric was cloned from",
                    "type": "string"
                },
                "compact": {
                    "$ref": "#/$defs/CompactOrAlias",
                    "description": "Compact format for large numbers"
                },
                "description": {
                    "description": "Description of what the metric measures",
                    "type": "string"
                },
                "distinctKeys": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "filters": {
                    "description": "Filters to apply to this metric",
                    "items": {
                        "$ref": "#/$defs/MetricFilterRule"
                    },
                    "type": "array"
                },
                "format": {
                    "anyOf": [
                        {
                            "$ref": "#/$defs/Format"
                        },
                        {
                            "type": "string"
                        }
                    ],
                    "description": "Format string (legacy format specification)"
                },
                "formatOptions": {
                    "$ref": "#/$defs/CustomFormat",
                    "description": "Formatting configuration"
                },
                "generationType": {
                    "description": "Optional marker for metrics generated by the system.\nCurrently used for Period-over-Period (PoP) previous-period metrics.",
                    "enum": ["periodOverPeriod"],
                    "type": "string"
                },
                "granularity": {
                    "$ref": "#/$defs/TimeFrames",
                    "description": "For PoP-generated metrics, the granularity used for the comparison."
                },
                "hidden": {
                    "description": "Whether the metric is hidden from users",
                    "type": "boolean"
                },
                "index": {
                    "description": "Display order index",
                    "format": "double",
                    "type": "number"
                },
                "label": {
                    "description": "Display label for the metric",
                    "type": "string"
                },
                "name": {
                    "description": "Internal name of the metric",
                    "type": "string"
                },
                "percentile": {
                    "description": "Percentile value for percentile metrics",
                    "format": "double",
                    "type": "number"
                },
                "periodOffset": {
                    "description": "For PoP-generated metrics, the number of periods to offset by (>= 1).",
                    "format": "double",
                    "type": "number"
                },
                "round": {
                    "description": "Number of decimal places",
                    "format": "double",
                    "type": "number"
                },
                "separator": {
                    "$ref": "#/$defs/NumberSeparator",
                    "description": "Number separator style for grouping/decimal characters"
                },
                "sql": {
                    "description": "SQL expression (e.g., ${TABLE}.column_name)",
                    "type": "string"
                },
                "table": {
                    "description": "Table name the metric belongs to",
                    "type": "string"
                },
                "timeDimensionId": {
                    "$ref": "#/$defs/FieldId",
                    "description": "For PoP-generated metrics, the time dimension id used for the comparison."
                },
                "type": {
                    "$ref": "#/$defs/MetricType",
                    "description": "Aggregation type"
                },
                "uuid": {
                    "description": "Unique identifier for the metric",
                    "type": ["string", "null"]
                }
            },
            "required": ["type", "sql", "table", "name"],
            "type": "object"
        },
        "AllVizChartConfig": {
            "anyOf": [
                {
                    "$ref": "#/$defs/VizBarChartConfig"
                },
                {
                    "$ref": "#/$defs/VizLineChartConfig"
                },
                {
                    "$ref": "#/$defs/VizPieChartConfig"
                },
                {
                    "$ref": "#/$defs/VizBigNumberConfig"
                },
                {
                    "$ref": "#/$defs/VizTableConfig"
                }
            ]
        },
        "AndFilterGroup": {
            "properties": {
                "and": {
                    "description": "Array of filters or nested groups combined with AND logic",
                    "items": {
                        "$ref": "#/$defs/FilterGroupItem"
                    },
                    "type": "array"
                },
                "id": {
                    "description": "Unique identifier for the filter group",
                    "type": "string"
                }
            },
            "required": ["and", "id"],
            "type": "object"
        },
        "AndFilterGroupInput": {
            "properties": {
                "and": {
                    "items": {
                        "$ref": "#/$defs/FilterGroupItemInput"
                    },
                    "type": "array"
                },
                "id": {
                    "type": "string"
                }
            },
            "required": ["and"],
            "type": "object"
        },
        "AnyType": {
            "description": "This AnyType is an alias for any\nThe goal is to make it easier to identify any type in the codebase\nwithout having to eslint-disable all the time\nThese are only used on legacy `any` types, don't use it for new types.\nThis is added on a separate file to avoid circular dependencies."
        },
        "Axis": {
            "properties": {
                "inverse": {
                    "description": "Reverse the axis direction",
                    "type": "boolean"
                },
                "max": {
                    "description": "Maximum value (or 'dataMax' for auto)",
                    "type": "string"
                },
                "maxOffset": {
                    "description": "Offset from maximum value",
                    "type": "string"
                },
                "min": {
                    "description": "Minimum value (or 'dataMin' for auto)",
                    "type": "string"
                },
                "minInterval": {
                    "description": "Minimum interval between ticks (e.g. 1 to force integer ticks)",
                    "format": "double",
                    "type": "number"
                },
                "minOffset": {
                    "description": "Offset from minimum value",
                    "type": "string"
                },
                "name": {
                    "description": "Axis title",
                    "type": "string"
                },
                "rotate": {
                    "description": "Rotation angle for axis labels",
                    "format": "double",
                    "type": "number"
                },
                "scale": {
                    "description": "Value scale: linear (default) or log base 10. Log applies to a\nvertical chart's value axis without stacks (PRpillar fork)",
                    "enum": ["linear", "log"],
                    "type": "string"
                }
            },
            "type": "object"
        },
        "AxisSide": {
            "enum": [0, 1],
            "type": "number"
        },
        "BaseFilterRule_FilterOperator.number-or-string_": {
            "properties": {
                "id": {
                    "description": "Unique identifier for the filter rule",
                    "type": "string"
                },
                "includeNull": {
                    "description": "For the `equals` operator on string fields, also match rows where the\nfield is null (compiles to `field IN (...) OR field IS NULL`). Lets users\ncombine null with selected values in a single \"is\" rule.",
                    "type": "boolean"
                },
                "operator": {
                    "$ref": "#/$defs/FilterOperator",
                    "description": "Filter operator"
                },
                "values": {
                    "description": "Values to filter by",
                    "items": {
                        "anyOf": [
                            {
                                "format": "double",
                                "type": "number"
                            },
                            {
                                "type": "string"
                            }
                        ]
                    },
                    "type": "array"
                }
            },
            "required": ["operator", "id"],
            "type": "object"
        },
        "BaseFilterRule_FilterOperator.number-or-string-or-boolean_": {
            "properties": {
                "id": {
                    "description": "Unique identifier for the filter rule",
                    "type": "string"
                },
                "includeNull": {
                    "description": "For the `equals` operator on string fields, also match rows where the\nfield is null (compiles to `field IN (...) OR field IS NULL`). Lets users\ncombine null with selected values in a single \"is\" rule.",
                    "type": "boolean"
                },
                "operator": {
                    "$ref": "#/$defs/FilterOperator",
                    "description": "Filter operator"
                },
                "values": {
                    "description": "Values to filter by",
                    "items": {
                        "anyOf": [
                            {
                                "format": "double",
                                "type": "number"
                            },
                            {
                                "type": "string"
                            },
                            {
                                "type": "boolean"
                            }
                        ]
                    },
                    "type": "array"
                }
            },
            "required": ["operator", "id"],
            "type": "object"
        },
        "BigNumber": {
            "properties": {
                "comparisonField": {
                    "type": "string"
                },
                "comparisonFormat": {
                    "$ref": "#/$defs/ComparisonFormatTypes",
                    "description": "Format for comparison value"
                },
                "comparisonLabel": {
                    "description": "Custom label for the comparison value",
                    "type": "string"
                },
                "conditionalFormattings": {
                    "description": "Conditional formatting rules",
                    "items": {
                        "$ref": "#/$defs/ConditionalFormattingConfig"
                    },
                    "type": "array"
                },
                "flipColors": {
                    "description": "Flip positive/negative colors (red for increase, green for decrease)",
                    "type": "boolean"
                },
                "label": {
                    "description": "Custom label for the big number",
                    "type": "string"
                },
                "selectedField": {
                    "description": "Field ID to display as the big number",
                    "type": "string"
                },
                "showBigNumberLabel": {
                    "description": "Show the label above the number",
                    "type": "boolean"
                },
                "showComparison": {
                    "description": "Show comparison with previous value",
                    "type": "boolean"
                },
                "showTableNamesInLabel": {
                    "description": "Include table name in the label",
                    "type": "boolean"
                },
                "style": {
                    "$ref": "#/$defs/CompactOrAlias",
                    "description": "Number formatting style (compact notation)"
                }
            },
            "type": "object"
        },
        "BigNumberConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/BigNumber",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.BIG_NUMBER",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "BinGroup": {
            "properties": {
                "name": {
                    "description": "Display name for this group (e.g. \"North America\")",
                    "type": "string"
                },
                "values": {
                    "description": "Rules that match values into this group",
                    "items": {
                        "$ref": "#/$defs/GroupValueRule"
                    },
                    "type": "array"
                }
            },
            "required": ["values", "name"],
            "type": "object"
        },
        "BinRange": {
            "properties": {
                "from": {
                    "description": "Start value for this bin range (undefined for the first range)",
                    "format": "double",
                    "type": "number"
                },
                "to": {
                    "description": "End value for this bin range (undefined for the last range)",
                    "format": "double",
                    "type": "number"
                }
            },
            "type": "object"
        },
        "BinType.CUSTOM_GROUP": {
            "enum": ["custom_group"],
            "type": "string"
        },
        "BinType.CUSTOM_RANGE": {
            "enum": ["custom_range"],
            "type": "string"
        },
        "BinType.FIXED_NUMBER": {
            "enum": ["fixed_number"],
            "type": "string"
        },
        "BinType.FIXED_WIDTH": {
            "enum": ["fixed_width"],
            "type": "string"
        },
        "CartesianChart": {
            "properties": {
                "columnLimit": {
                    "description": "Maximum number of pivot columns to display",
                    "format": "double",
                    "type": "number"
                },
                "conditionalFormattings": {
                    "description": "Conditional formatting rules",
                    "items": {
                        "$ref": "#/$defs/ConditionalFormattingConfig"
                    },
                    "type": "array"
                },
                "eChartsConfig": {
                    "$ref": "#/$defs/EChartsConfig",
                    "description": "ECharts-specific configuration"
                },
                "layout": {
                    "$ref": "#/$defs/CartesianChartLayout",
                    "description": "Layout configuration for the chart axes and orientation"
                },
                "metadata": {
                    "$ref": "#/$defs/Record_string.SeriesMetadata_",
                    "description": "Metadata for series (colors, etc.)"
                },
                "rowLimit": {
                    "$ref": "#/$defs/RowLimit",
                    "description": "Limit displayed rows to first/last N"
                }
            },
            "required": ["eChartsConfig", "layout"],
            "type": "object"
        },
        "CartesianChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/CartesianChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.CARTESIAN",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "CartesianChartDisplay": {
            "properties": {
                "legend": {
                    "properties": {
                        "align": {
                            "enum": ["start", "center", "end"],
                            "type": "string"
                        },
                        "position": {
                            "enum": ["top", "bottom", "left", "right"],
                            "type": "string"
                        }
                    },
                    "required": ["align", "position"],
                    "type": "object"
                },
                "series": {
                    "additionalProperties": {
                        "properties": {
                            "color": {
                                "type": "string"
                            },
                            "format": {
                                "$ref": "#/$defs/Format"
                            },
                            "label": {
                                "type": "string"
                            },
                            "type": {
                                "anyOf": [
                                    {
                                        "$ref": "#/$defs/CartesianSeriesType.LINE"
                                    },
                                    {
                                        "$ref": "#/$defs/CartesianSeriesType.BAR"
                                    }
                                ]
                            },
                            "valueLabelColor": {
                                "type": "string"
                            },
                            "valueLabelPosition": {
                                "$ref": "#/$defs/ValueLabelPositionOptions"
                            },
                            "whichYAxis": {
                                "$ref": "#/$defs/AxisSide"
                            },
                            "yAxisIndex": {
                                "format": "double",
                                "type": "number"
                            }
                        },
                        "type": "object"
                    },
                    "properties": {},
                    "type": "object"
                },
                "seriesOrder": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "stack": {
                    "anyOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "$ref": "#/$defs/StackType"
                        }
                    ]
                },
                "xAxis": {
                    "properties": {
                        "dateFormat": {
                            "type": "string"
                        },
                        "label": {
                            "type": "string"
                        },
                        "type": {
                            "$ref": "#/$defs/VizIndexType"
                        }
                    },
                    "type": "object"
                },
                "yAxis": {
                    "items": {
                        "properties": {
                            "format": {
                                "$ref": "#/$defs/Format"
                            },
                            "label": {
                                "type": "string"
                            },
                            "position": {
                                "type": "string"
                            }
                        },
                        "type": "object"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "CartesianChartLayout": {
            "$ref": "#/$defs/Partial_CompleteCartesianChartLayout_"
        },
        "CartesianSeriesType": {
            "enum": ["line", "bar", "scatter", "area"],
            "type": "string"
        },
        "CartesianSeriesType.BAR": {
            "enum": ["bar"],
            "type": "string"
        },
        "CartesianSeriesType.LINE": {
            "enum": ["line"],
            "type": "string"
        },
        "ChartAsCode": {
            "additionalProperties": false,
            "description": "A semantic layer chart: queries an explore with tableName and metricQuery",
            "properties": {
                "access": {
                    "$ref": "#/$defs/ContentAsCodeDirectAccess",
                    "description": "Direct user/group grants on this chart. Only independently saved charts\ncarry one — dashboard-owned chart definitions are not grantable.\nOmission leaves the existing policy unchanged on upload."
                },
                "chartConfig": {
                    "discriminator": {
                        "propertyName": "type"
                    },
                    "oneOf": [
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/BigNumber",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "big_number",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/CartesianChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "cartesian",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/CustomVis",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "custom",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/PieChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "pie",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/FunnelChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "funnel",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/TableChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "table",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/TreemapChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "treemap",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/GaugeChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "gauge",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/MapChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "map",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/SankeyChart",
                                    "description": "Chart-type-specific configuration"
                                },
                                "type": {
                                    "const": "sankey",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/CustomCodeChart",
                                    "description": "HTML/JS component rendered in a sandboxed iframe (PRpillar fork)"
                                },
                                "type": {
                                    "const": "custom_code",
                                    "description": "Type of chart visualization"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        },
                        {
                            "properties": {
                                "config": {
                                    "$ref": "#/$defs/DataAppVizChartAsCode"
                                },
                                "type": {
                                    "const": "data_app_viz"
                                }
                            },
                            "required": ["type"],
                            "type": "object"
                        }
                    ],
                    "type": "object"
                },
                "contentType": {
                    "$ref": "#/$defs/ContentAsCodeType.CHART",
                    "description": "Content type discriminator"
                },
                "dashboardSlug": {
                    "description": "Slug of the dashboard this chart belongs to (if any)",
                    "oneOf": [
                        {
                            "pattern": "^[a-z0-9-]+$",
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "description": {
                    "description": "Optional description of what this chart displays",
                    "type": "string"
                },
                "downloadedAt": {
                    "description": "Timestamp when this chart was downloaded from Lightdash",
                    "format": "date-time",
                    "type": "string"
                },
                "merge": {
                    "anyOf": [
                        {
                            "anyOf": [
                                {
                                    "$ref": "#/$defs/SavedMergeDefinition"
                                },
                                {
                                    "$ref": "#/$defs/SavedMergeQuery"
                                }
                            ]
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "metricQuery": {
                    "allOf": [
                        {
                            "$ref": "#/$defs/Omit_MetricQuery.filters_"
                        },
                        {
                            "properties": {
                                "filters": {
                                    "$ref": "#/$defs/FiltersInput"
                                }
                            },
                            "required": ["filters"],
                            "type": "object"
                        }
                    ]
                },
                "name": {
                    "description": "Display name of the chart",
                    "type": "string"
                },
                "parameters": {
                    "$ref": "#/$defs/ParametersValuesMap",
                    "description": "Parameter values for the chart query"
                },
                "pivotConfig": {
                    "description": "Pivot table configuration",
                    "properties": {
                        "columns": {
                            "description": "Fields to use as pivot columns",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "rows": {
                            "description": "Ordered fields to render on the pivot row axis",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns"],
                    "type": "object"
                },
                "slug": {
                    "description": "Unique identifier slug for this chart",
                    "type": "string"
                },
                "spaceSlug": {
                    "description": "Slug of the space containing this chart",
                    "type": "string"
                },
                "tableConfig": {
                    "description": "Table configuration. Defaults to empty column order if omitted.",
                    "properties": {
                        "columnOrder": {
                            "description": "Order of columns in table view",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columnOrder"],
                    "type": "object"
                },
                "tableName": {
                    "description": "The explore/table name this chart queries from",
                    "type": "string"
                },
                "updatedAt": {
                    "description": "Not modifiable by user, but useful to know if it has been updated. Defaults to now if omitted.",
                    "format": "date-time",
                    "type": "string"
                },
                "verification": {
                    "anyOf": [
                        {
                            "allOf": [
                                {
                                    "$ref": "#/$defs/ContentVerificationInfo"
                                }
                            ],
                            "description": "Detailed verification info (who/when). Read-only; ignored on upload."
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "verified": {
                    "description": "Declarative verification state.\n`true` verifies the chart on upload, `false` unverifies it, `undefined` leaves the\ncurrent state untouched. Download sets this to `true` when the chart is verified.",
                    "type": "boolean"
                },
                "version": {
                    "const": 1,
                    "description": "Schema version for this chart configuration",
                    "format": "double",
                    "type": "number"
                }
            },
            "required": [
                "name",
                "tableName",
                "slug",
                "spaceSlug",
                "version",
                "chartConfig",
                "metricQuery"
            ],
            "type": "object"
        },
        "ChartAsCodeConfig": {
            "anyOf": [
                {
                    "$ref": "#/$defs/BigNumberConfig"
                },
                {
                    "$ref": "#/$defs/CartesianChartConfig"
                },
                {
                    "$ref": "#/$defs/CustomVisConfig"
                },
                {
                    "$ref": "#/$defs/PieChartConfig"
                },
                {
                    "$ref": "#/$defs/FunnelChartConfig"
                },
                {
                    "$ref": "#/$defs/TableChartConfig"
                },
                {
                    "$ref": "#/$defs/TreemapChartConfig"
                },
                {
                    "$ref": "#/$defs/GaugeChartConfig"
                },
                {
                    "$ref": "#/$defs/MapChartConfig"
                },
                {
                    "$ref": "#/$defs/SankeyChartConfig"
                },
                {
                    "$ref": "#/$defs/CustomCodeChartConfig"
                },
                {
                    "$ref": "#/$defs/DataAppVizChartConfigAsCode"
                }
            ],
            "description": "ChartConfig as serialized in chart YAML: viz bindings are slug-based.\nEnumerated rather than Exclude<ChartConfig, DataAppVizChartConfig> —\nTSOA cannot resolve Exclude over object unions, which corrupts the\ngenerated chart-as-code JSON schema. Keep in sync with ChartConfig."
        },
        "ChartKind": {
            "enum": [
                "line",
                "horizontal_bar",
                "vertical_bar",
                "scatter",
                "area",
                "mixed",
                "pie",
                "table",
                "big_number",
                "funnel",
                "custom",
                "treemap",
                "gauge",
                "map",
                "sankey",
                "data_app_viz",
                "custom_code"
            ],
            "type": "string"
        },
        "ChartKind.BIG_NUMBER": {
            "enum": ["big_number"],
            "type": "string"
        },
        "ChartKind.LINE": {
            "enum": ["line"],
            "type": "string"
        },
        "ChartKind.PIE": {
            "enum": ["pie"],
            "type": "string"
        },
        "ChartKind.TABLE": {
            "enum": ["table"],
            "type": "string"
        },
        "ChartKind.VERTICAL_BAR": {
            "enum": ["vertical_bar"],
            "type": "string"
        },
        "ChartType.BIG_NUMBER": {
            "enum": ["big_number"],
            "type": "string"
        },
        "ChartType.CARTESIAN": {
            "enum": ["cartesian"],
            "type": "string"
        },
        "ChartType.CUSTOM": {
            "enum": ["custom"],
            "type": "string"
        },
        "ChartType.CUSTOM_CODE": {
            "enum": ["custom_code"],
            "type": "string"
        },
        "ChartType.DATA_APP_VIZ": {
            "enum": ["data_app_viz"],
            "type": "string"
        },
        "ChartType.FUNNEL": {
            "enum": ["funnel"],
            "type": "string"
        },
        "ChartType.GAUGE": {
            "enum": ["gauge"],
            "type": "string"
        },
        "ChartType.MAP": {
            "enum": ["map"],
            "type": "string"
        },
        "ChartType.PIE": {
            "enum": ["pie"],
            "type": "string"
        },
        "ChartType.SANKEY": {
            "enum": ["sankey"],
            "type": "string"
        },
        "ChartType.TABLE": {
            "enum": ["table"],
            "type": "string"
        },
        "ChartType.TREEMAP": {
            "enum": ["treemap"],
            "type": "string"
        },
        "ColumnProperties": {
            "properties": {
                "color": {
                    "description": "Color for bar display style (hex code)",
                    "type": "string"
                },
                "displayStyle": {
                    "description": "How to display the cell value",
                    "enum": ["text", "bar"],
                    "type": "string"
                },
                "frozen": {
                    "description": "Freeze the column (stick to left side)",
                    "type": "boolean"
                },
                "name": {
                    "description": "Custom display name for the column",
                    "type": "string"
                },
                "negativeColor": {
                    "description": "Color for negative bars in diverging bar display (hex code). Falls back to `color` when unset.",
                    "type": "string"
                },
                "visible": {
                    "description": "Whether the column is visible",
                    "type": "boolean"
                },
                "width": {
                    "format": "double",
                    "type": "number"
                }
            },
            "type": "object"
        },
        "Compact": {
            "enum": [
                "auto",
                "thousands",
                "millions",
                "billions",
                "trillions",
                "kilobytes",
                "megabytes",
                "gigabytes",
                "terabytes",
                "petabytes",
                "kibibytes",
                "mebibytes",
                "gibibytes",
                "tebibytes",
                "pebibytes"
            ],
            "type": "string"
        },
        "CompactOrAlias": {
            "anyOf": [
                {
                    "$ref": "#/$defs/Compact"
                },
                {
                    "enum": [
                        "K",
                        "thousand",
                        "M",
                        "million",
                        "B",
                        "billion",
                        "T",
                        "trillion",
                        "KB",
                        "kilobyte",
                        "MB",
                        "megabyte",
                        "GB",
                        "gigabyte",
                        "TB",
                        "terabyte",
                        "PB",
                        "petabyte",
                        "KiB",
                        "kibibyte",
                        "MiB",
                        "mebibyte",
                        "GiB",
                        "gibibyte",
                        "TiB",
                        "tebibyte",
                        "PiB",
                        "pebibyte"
                    ],
                    "type": "string"
                }
            ]
        },
        "ComparisonFormatTypes": {
            "enum": ["raw", "percentage"],
            "type": "string"
        },
        "ConditionalFormattingColorApplyTo": {
            "enum": ["cell", "text", "row"],
            "type": "string"
        },
        "ConditionalFormattingColorRange": {
            "properties": {
                "end": {
                    "description": "End color for gradient",
                    "type": "string"
                },
                "start": {
                    "description": "Start color for gradient",
                    "type": "string"
                }
            },
            "required": ["end", "start"],
            "type": "object"
        },
        "ConditionalFormattingConfig": {
            "anyOf": [
                {
                    "$ref": "#/$defs/ConditionalFormattingConfigWithSingleColor"
                },
                {
                    "$ref": "#/$defs/ConditionalFormattingConfigWithColorRange"
                }
            ]
        },
        "ConditionalFormattingConfigWithColorRange": {
            "properties": {
                "applyTo": {
                    "$ref": "#/$defs/ConditionalFormattingColorApplyTo",
                    "description": "Apply formatting to cell background or text"
                },
                "color": {
                    "$ref": "#/$defs/ConditionalFormattingColorRange",
                    "description": "Color range for gradient conditional formatting"
                },
                "rule": {
                    "$ref": "#/$defs/ConditionalFormattingMinMax_number-or-auto_",
                    "description": "Rule for color range formatting (min/max values)"
                },
                "target": {
                    "anyOf": [
                        {
                            "allOf": [
                                {
                                    "$ref": "#/$defs/FieldTarget"
                                }
                            ],
                            "description": "Target field for the formatting rule"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "textStyle": {
                    "$ref": "#/$defs/ConditionalFormattingTextStyle",
                    "description": "Text styling (bold/italic/underline) applied to matching cell text"
                }
            },
            "required": ["rule", "color", "target"],
            "type": "object"
        },
        "ConditionalFormattingConfigWithSingleColor": {
            "properties": {
                "applyTo": {
                    "$ref": "#/$defs/ConditionalFormattingColorApplyTo",
                    "description": "Apply formatting to cell background or text"
                },
                "color": {
                    "description": "Color for single-color conditional formatting",
                    "type": "string"
                },
                "darkColor": {
                    "description": "Color for dark mode",
                    "type": "string"
                },
                "rules": {
                    "description": "Rules for single-color conditional formatting.\nThe number|string members are redundant for TypeScript (absorbed by the\nboolean-capable defaults) but keep the pre-boolean schema components in\nthe generated OpenAPI anyOf, so the API change stays expand-only.",
                    "items": {
                        "anyOf": [
                            {
                                "$ref": "#/$defs/ConditionalFormattingWithValues_number-or-string_"
                            },
                            {
                                "$ref": "#/$defs/ConditionalFormattingWithCompareTarget_number-or-string_"
                            },
                            {
                                "$ref": "#/$defs/ConditionalFormattingWithValues"
                            },
                            {
                                "$ref": "#/$defs/ConditionalFormattingWithCompareTarget"
                            }
                        ]
                    },
                    "type": "array"
                },
                "target": {
                    "anyOf": [
                        {
                            "allOf": [
                                {
                                    "$ref": "#/$defs/FieldTarget"
                                }
                            ],
                            "description": "Target field for the formatting rule"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "textStyle": {
                    "$ref": "#/$defs/ConditionalFormattingTextStyle",
                    "description": "Text styling (bold/italic/underline) applied to matching cell text"
                }
            },
            "required": ["rules", "color", "target"],
            "type": "object"
        },
        "ConditionalFormattingMinMax_number-or-auto_": {
            "properties": {
                "max": {
                    "anyOf": [
                        {
                            "format": "double",
                            "type": "number"
                        },
                        {
                            "enum": ["auto"],
                            "type": "string"
                        }
                    ],
                    "description": "Maximum value (number or 'auto')"
                },
                "min": {
                    "anyOf": [
                        {
                            "format": "double",
                            "type": "number"
                        },
                        {
                            "enum": ["auto"],
                            "type": "string"
                        }
                    ],
                    "description": "Minimum value (number or 'auto')"
                }
            },
            "required": ["max", "min"],
            "type": "object"
        },
        "ConditionalFormattingTextStyle": {
            "properties": {
                "bold": {
                    "description": "Render matching cell text in bold",
                    "type": "boolean"
                },
                "italic": {
                    "description": "Render matching cell text in italics",
                    "type": "boolean"
                },
                "underline": {
                    "description": "Underline matching cell text",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "ConditionalFormattingWithCompareTarget": {
            "allOf": [
                {
                    "$ref": "#/$defs/BaseFilterRule_FilterOperator.number-or-string-or-boolean_"
                },
                {
                    "properties": {
                        "compareTarget": {
                            "anyOf": [
                                {
                                    "allOf": [
                                        {
                                            "$ref": "#/$defs/FieldTarget"
                                        }
                                    ],
                                    "description": "Target field to compare against"
                                },
                                {
                                    "type": "null"
                                }
                            ]
                        },
                        "values": {
                            "description": "Values to compare against",
                            "items": {
                                "anyOf": [
                                    {
                                        "format": "double",
                                        "type": "number"
                                    },
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "boolean"
                                    }
                                ]
                            },
                            "type": "array"
                        }
                    },
                    "required": ["compareTarget"],
                    "type": "object"
                }
            ]
        },
        "ConditionalFormattingWithCompareTarget_number-or-string_": {
            "allOf": [
                {
                    "$ref": "#/$defs/BaseFilterRule_FilterOperator.number-or-string_"
                },
                {
                    "properties": {
                        "compareTarget": {
                            "anyOf": [
                                {
                                    "allOf": [
                                        {
                                            "$ref": "#/$defs/FieldTarget"
                                        }
                                    ],
                                    "description": "Target field to compare against"
                                },
                                {
                                    "type": "null"
                                }
                            ]
                        },
                        "values": {
                            "description": "Values to compare against",
                            "items": {
                                "anyOf": [
                                    {
                                        "format": "double",
                                        "type": "number"
                                    },
                                    {
                                        "type": "string"
                                    }
                                ]
                            },
                            "type": "array"
                        }
                    },
                    "required": ["compareTarget"],
                    "type": "object"
                }
            ]
        },
        "ConditionalFormattingWithValues": {
            "allOf": [
                {
                    "$ref": "#/$defs/BaseFilterRule_FilterOperator.number-or-string-or-boolean_"
                },
                {
                    "properties": {
                        "values": {
                            "description": "Values to compare against",
                            "items": {
                                "anyOf": [
                                    {
                                        "format": "double",
                                        "type": "number"
                                    },
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "boolean"
                                    }
                                ]
                            },
                            "type": "array"
                        }
                    },
                    "required": ["values"],
                    "type": "object"
                }
            ]
        },
        "ConditionalFormattingWithValues_number-or-string_": {
            "allOf": [
                {
                    "$ref": "#/$defs/BaseFilterRule_FilterOperator.number-or-string_"
                },
                {
                    "properties": {
                        "values": {
                            "description": "Values to compare against",
                            "items": {
                                "anyOf": [
                                    {
                                        "format": "double",
                                        "type": "number"
                                    },
                                    {
                                        "type": "string"
                                    }
                                ]
                            },
                            "type": "array"
                        }
                    },
                    "required": ["values"],
                    "type": "object"
                }
            ]
        },
        "ContentAsCodeDirectAccess": {
            "description": "Portable direct user/group grants on a single resource. Mirrors the space\naccess block: principals are identified by organization email or group name,\nnever by internal identifiers. Inherited and effective roles are never part\nof this shape — it reflects stored direct policy only.\n\nOn upload: omission leaves the resource's existing direct policy unchanged;\na present block (including empty `users` and `groups`) atomically replaces\nthe whole policy.",
            "properties": {
                "groups": {
                    "items": {
                        "$ref": "#/$defs/ContentAsCodeDirectAccessGroup"
                    },
                    "type": "array"
                },
                "users": {
                    "items": {
                        "$ref": "#/$defs/ContentAsCodeDirectAccessUser"
                    },
                    "type": "array"
                }
            },
            "required": ["groups", "users"],
            "type": "object"
        },
        "ContentAsCodeDirectAccessGroup": {
            "properties": {
                "name": {
                    "description": "Exact, case-sensitive organization group name.",
                    "type": "string"
                },
                "role": {
                    "$ref": "#/$defs/SpaceMemberRole"
                }
            },
            "required": ["role", "name"],
            "type": "object"
        },
        "ContentAsCodeDirectAccessUser": {
            "properties": {
                "email": {
                    "description": "Primary email of a human organization member.",
                    "type": "string"
                },
                "role": {
                    "$ref": "#/$defs/SpaceMemberRole"
                }
            },
            "required": ["role", "email"],
            "type": "object"
        },
        "ContentAsCodeType.CHART": {
            "enum": ["chart"],
            "type": "string"
        },
        "ContentAsCodeType.SQL_CHART": {
            "enum": ["sql_chart"],
            "type": "string"
        },
        "ContentVerificationInfo": {
            "properties": {
                "verifiedAt": {
                    "format": "date-time",
                    "type": "string"
                },
                "verifiedBy": {
                    "properties": {
                        "firstName": {
                            "type": "string"
                        },
                        "lastName": {
                            "type": "string"
                        },
                        "userUuid": {
                            "type": "string"
                        }
                    },
                    "required": ["lastName", "firstName", "userUuid"],
                    "type": "object"
                }
            },
            "required": ["verifiedAt", "verifiedBy"],
            "type": "object"
        },
        "CustomBinDimension": {
            "anyOf": [
                {
                    "$ref": "#/$defs/FixedNumberBinDimension"
                },
                {
                    "$ref": "#/$defs/FixedWidthBinDimension"
                },
                {
                    "$ref": "#/$defs/CustomRangeBinDimension"
                },
                {
                    "$ref": "#/$defs/CustomGroupBinDimension"
                }
            ]
        },
        "CustomCodeChart": {
            "properties": {
                "height": {
                    "anyOf": [
                        {
                            "format": "double",
                            "type": "number"
                        },
                        {
                            "enum": ["auto"],
                            "type": "string"
                        }
                    ],
                    "description": "Tile height in pixels, or 'auto' to follow `lightdash.resize(h)`"
                },
                "options": {
                    "$ref": "#/$defs/Record_string.unknown_",
                    "description": "Free-form parameters passed to the component as `options`"
                },
                "source": {
                    "description": "HTML document of the component. Runs in a sandboxed iframe without\nnetwork access; receives data through `window.lightdash.onData`.",
                    "maxLength": 262144,
                    "type": "string"
                }
            },
            "type": "object"
        },
        "CustomCodeChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/CustomCodeChart",
                    "description": "HTML/JS component rendered in a sandboxed iframe (PRpillar fork)"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.CUSTOM_CODE",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "CustomDimension": {
            "anyOf": [
                {
                    "$ref": "#/$defs/CustomBinDimension"
                },
                {
                    "$ref": "#/$defs/CustomSqlDimension"
                }
            ]
        },
        "CustomDimensionType.BIN": {
            "enum": ["bin"],
            "type": "string"
        },
        "CustomDimensionType.SQL": {
            "enum": ["sql"],
            "type": "string"
        },
        "CustomFormat": {
            "additionalProperties": true,
            "properties": {
                "compact": {
                    "$ref": "#/$defs/CompactOrAlias",
                    "description": "Compact format for large numbers (K, M, B, T) or byte units"
                },
                "currency": {
                    "description": "Currency code (e.g., USD, GBP, EUR)",
                    "type": "string"
                },
                "custom": {
                    "description": "Custom format string",
                    "type": "string"
                },
                "prefix": {
                    "description": "Prefix to prepend to formatted values",
                    "type": "string"
                },
                "round": {
                    "description": "Number of decimal places",
                    "format": "double",
                    "type": "number"
                },
                "separator": {
                    "$ref": "#/$defs/NumberSeparator",
                    "description": "Number separator style"
                },
                "suffix": {
                    "description": "Suffix to append to formatted values",
                    "type": "string"
                },
                "timeInterval": {
                    "$ref": "#/$defs/TimeFrames",
                    "description": "Time interval for date formatting"
                },
                "type": {
                    "$ref": "#/$defs/CustomFormatType",
                    "description": "Format type"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "CustomFormatType": {
            "enum": [
                "default",
                "percent",
                "currency",
                "number",
                "id",
                "date",
                "timestamp",
                "bytes_si",
                "bytes_iec",
                "custom"
            ],
            "type": "string"
        },
        "CustomGroupBinDimension": {
            "additionalProperties": true,
            "properties": {
                "binType": {
                    "$ref": "#/$defs/BinType.CUSTOM_GROUP"
                },
                "customGroups": {
                    "items": {
                        "$ref": "#/$defs/BinGroup"
                    },
                    "type": "array"
                },
                "dimensionId": {
                    "$ref": "#/$defs/FieldId",
                    "description": "Field ID of the parent dimension to bin"
                },
                "id": {
                    "description": "Unique identifier for the custom dimension",
                    "type": "string"
                },
                "name": {
                    "description": "Display name for the custom dimension",
                    "type": "string"
                },
                "table": {
                    "description": "Table this custom dimension belongs to",
                    "type": "string"
                },
                "type": {
                    "$ref": "#/$defs/CustomDimensionType.BIN",
                    "description": "Type of custom dimension (bin or sql)"
                }
            },
            "required": [
                "id",
                "name",
                "table",
                "type",
                "dimensionId",
                "binType",
                "customGroups"
            ],
            "type": "object"
        },
        "CustomRangeBinDimension": {
            "additionalProperties": true,
            "properties": {
                "binType": {
                    "$ref": "#/$defs/BinType.CUSTOM_RANGE"
                },
                "customRange": {
                    "items": {
                        "$ref": "#/$defs/BinRange"
                    },
                    "type": "array"
                },
                "dimensionId": {
                    "$ref": "#/$defs/FieldId",
                    "description": "Field ID of the parent dimension to bin"
                },
                "id": {
                    "description": "Unique identifier for the custom dimension",
                    "type": "string"
                },
                "name": {
                    "description": "Display name for the custom dimension",
                    "type": "string"
                },
                "table": {
                    "description": "Table this custom dimension belongs to",
                    "type": "string"
                },
                "type": {
                    "$ref": "#/$defs/CustomDimensionType.BIN",
                    "description": "Type of custom dimension (bin or sql)"
                }
            },
            "required": [
                "id",
                "name",
                "table",
                "type",
                "dimensionId",
                "binType",
                "customRange"
            ],
            "type": "object"
        },
        "CustomSqlDimension": {
            "additionalProperties": true,
            "properties": {
                "dimensionType": {
                    "$ref": "#/$defs/DimensionType",
                    "description": "Data type of the dimension result"
                },
                "id": {
                    "description": "Unique identifier for the custom dimension",
                    "type": "string"
                },
                "name": {
                    "description": "Display name for the custom dimension",
                    "type": "string"
                },
                "sql": {
                    "description": "SQL expression for the custom dimension",
                    "type": "string"
                },
                "table": {
                    "description": "Table this custom dimension belongs to",
                    "type": "string"
                },
                "type": {
                    "$ref": "#/$defs/CustomDimensionType.SQL",
                    "description": "Type of custom dimension (bin or sql)"
                }
            },
            "required": ["id", "name", "table", "type", "sql", "dimensionType"],
            "type": "object"
        },
        "CustomVis": {
            "properties": {
                "spec": {
                    "$ref": "#/$defs/Record_string.unknown_",
                    "description": "Custom visualization specification (Vega-Lite or other)"
                }
            },
            "type": "object"
        },
        "CustomVisConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/CustomVis",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.CUSTOM",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "DataAppVizChartAsCode": {
            "allOf": [
                {
                    "$ref": "#/$defs/Omit_DataAppVizChart.dataAppVizUuid-or-dataAppVizVersion_"
                },
                {
                    "properties": {
                        "dataAppVizSlug": {
                            "type": "string"
                        },
                        "dataAppVizUuid": {
                            "type": "string"
                        },
                        "dataAppVizVersion": {
                            "description": "The version of the custom chart type this saved chart renders.",
                            "format": "int32",
                            "minimum": 1,
                            "type": "integer"
                        }
                    },
                    "type": "object"
                }
            ],
            "description": "The as-code shape of a custom chart type binding. Files carry the viz's\nproject-scoped slug — portable across projects/instances — and upload\nresolves it to the target project's viz uuid. Exactly one identity is\npresent: `dataAppVizSlug` in every file written today; `dataAppVizUuid`\nonly in legacy files that predate slugs (accepted on upload, never\nemitted)."
        },
        "DataAppVizChartConfigAsCode": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/DataAppVizChartAsCode"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.DATA_APP_VIZ"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "DataAppVizFieldMapping": {
            "$ref": "#/$defs/Record_string.string-or-string-Array_",
            "description": "Maps a viz field name to one query field id or an ordered collection."
        },
        "DataAppVizGradientValue": {
            "properties": {
                "colors": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "max": {
                    "anyOf": [
                        {
                            "format": "double",
                            "type": "number"
                        },
                        {
                            "enum": ["auto"],
                            "type": "string"
                        }
                    ]
                },
                "min": {
                    "anyOf": [
                        {
                            "format": "double",
                            "type": "number"
                        },
                        {
                            "enum": ["auto"],
                            "type": "string"
                        }
                    ]
                }
            },
            "required": ["max", "min", "colors"],
            "type": "object"
        },
        "DataAppVizOptionValue": {
            "anyOf": [
                {
                    "type": "boolean"
                },
                {
                    "format": "double",
                    "type": "number"
                },
                {
                    "type": "string"
                },
                {
                    "$ref": "#/$defs/DataAppVizGradientValue"
                }
            ],
            "description": "A persisted config value; its shape is set by the option's declared `type`."
        },
        "DataAppVizOptionValues": {
            "$ref": "#/$defs/Record_string.DataAppVizOptionValue_",
            "description": "Maps a declared config option's name → the value the user chose for it."
        },
        "DimensionOverrides": {
            "additionalProperties": {
                "$ref": "#/$defs/Pick_Dimension.formatOptions_"
            },
            "properties": {},
            "type": "object"
        },
        "DimensionType": {
            "enum": ["string", "number", "timestamp", "date", "boolean"],
            "type": "string"
        },
        "EChartsConfig": {
            "$ref": "#/$defs/Partial_CompleteEChartsConfig_"
        },
        "EchartsGrid": {
            "properties": {
                "bottom": {
                    "description": "Bottom padding",
                    "type": "string"
                },
                "containLabel": {
                    "description": "Whether the grid area contains axis labels",
                    "type": "boolean"
                },
                "height": {
                    "description": "Grid height",
                    "type": "string"
                },
                "left": {
                    "description": "Left padding",
                    "type": "string"
                },
                "right": {
                    "description": "Right padding",
                    "type": "string"
                },
                "top": {
                    "description": "Top padding",
                    "type": "string"
                },
                "width": {
                    "description": "Grid width",
                    "type": "string"
                }
            },
            "type": "object"
        },
        "EchartsLegend": {
            "properties": {
                "align": {
                    "description": "Legend alignment",
                    "enum": ["auto", "left", "right"],
                    "type": "string"
                },
                "bottom": {
                    "description": "Bottom position",
                    "type": "string"
                },
                "height": {
                    "description": "Legend height",
                    "type": "string"
                },
                "icon": {
                    "description": "Legend icon shape",
                    "enum": [
                        "circle",
                        "rect",
                        "roundRect",
                        "triangle",
                        "diamond",
                        "pin",
                        "arrow",
                        "none"
                    ],
                    "type": "string"
                },
                "left": {
                    "description": "Left position",
                    "type": "string"
                },
                "orient": {
                    "description": "Legend orientation",
                    "enum": ["horizontal", "vertical"],
                    "type": "string"
                },
                "placement": {
                    "$ref": "#/$defs/LegendPlacement",
                    "description": "High-level placement preset. Overrides orient/top/right/bottom/left\nwhen set to an outside value."
                },
                "right": {
                    "description": "Right position",
                    "type": "string"
                },
                "selected": {
                    "$ref": "#/$defs/Record_string.boolean_",
                    "description": "Legend entries toggled off by name. Missing entries default to visible."
                },
                "show": {
                    "description": "Show the legend",
                    "type": "boolean"
                },
                "top": {
                    "description": "Top position",
                    "type": "string"
                },
                "type": {
                    "description": "Legend type (plain or scrollable)",
                    "enum": ["plain", "scroll"],
                    "type": "string"
                },
                "width": {
                    "description": "Legend width",
                    "type": "string"
                }
            },
            "type": "object"
        },
        "FieldId": {
            "type": "string"
        },
        "FieldTarget": {
            "properties": {
                "fieldId": {
                    "description": "Field ID to filter on",
                    "type": "string"
                }
            },
            "required": ["fieldId"],
            "type": "object"
        },
        "FilterGroup": {
            "anyOf": [
                {
                    "$ref": "#/$defs/OrFilterGroup"
                },
                {
                    "$ref": "#/$defs/AndFilterGroup"
                }
            ]
        },
        "FilterGroupInput": {
            "anyOf": [
                {
                    "$ref": "#/$defs/OrFilterGroupInput"
                },
                {
                    "$ref": "#/$defs/AndFilterGroupInput"
                }
            ]
        },
        "FilterGroupItem": {
            "anyOf": [
                {
                    "$ref": "#/$defs/FilterGroup"
                },
                {
                    "$ref": "#/$defs/FilterRule"
                }
            ]
        },
        "FilterGroupItemInput": {
            "anyOf": [
                {
                    "$ref": "#/$defs/FilterGroupInput"
                },
                {
                    "$ref": "#/$defs/FilterRuleInput"
                }
            ]
        },
        "FilterOperator": {
            "enum": [
                "isNull",
                "notNull",
                "equals",
                "notEquals",
                "startsWith",
                "endsWith",
                "include",
                "doesNotInclude",
                "lessThan",
                "lessThanOrEqual",
                "greaterThan",
                "greaterThanOrEqual",
                "inThePast",
                "notInThePast",
                "inTheNext",
                "inTheCurrent",
                "notInTheCurrent",
                "inBetween",
                "notInBetween",
                "inPeriodToDate"
            ],
            "type": "string"
        },
        "FilterOperator.EQUALS": {
            "enum": ["equals"],
            "type": "string"
        },
        "FilterOperator.GREATER_THAN": {
            "enum": ["greaterThan"],
            "type": "string"
        },
        "FilterOperator.GREATER_THAN_OR_EQUAL": {
            "enum": ["greaterThanOrEqual"],
            "type": "string"
        },
        "FilterOperator.LESS_THAN": {
            "enum": ["lessThan"],
            "type": "string"
        },
        "FilterOperator.LESS_THAN_OR_EQUAL": {
            "enum": ["lessThanOrEqual"],
            "type": "string"
        },
        "FilterOperator.NOT_EQUALS": {
            "enum": ["notEquals"],
            "type": "string"
        },
        "FilterRule": {
            "additionalProperties": true,
            "properties": {
                "caseSensitive": {
                    "description": "Overrides the field/explore case-sensitivity for this rule only.\nUsed by internal features like autocomplete search that must always\nmatch case-insensitively regardless of the field's configured setting.",
                    "type": "boolean"
                },
                "disabled": {
                    "description": "Whether this filter is disabled",
                    "type": "boolean"
                },
                "id": {
                    "description": "Unique identifier for the filter",
                    "type": "string"
                },
                "includeNull": {
                    "description": "For the `equals` operator on string fields, also match rows where the\nfield is null (compiles to `field IN (...) OR field IS NULL`). Lets users\ncombine null with selected values in a single \"is\" rule.",
                    "type": "boolean"
                },
                "operator": {
                    "$ref": "#/$defs/FilterOperator",
                    "description": "Filter operator"
                },
                "required": {
                    "description": "Whether this filter is required",
                    "type": "boolean"
                },
                "settings": {
                    "$ref": "#/$defs/AnyType",
                    "description": "Additional settings for date/time filters"
                },
                "target": {
                    "$ref": "#/$defs/FieldTarget",
                    "description": "Target field for the filter"
                },
                "values": {
                    "description": "Values to filter by",
                    "items": {
                        "$ref": "#/$defs/AnyType"
                    },
                    "type": "array"
                }
            },
            "required": ["operator", "id", "target"],
            "type": "object"
        },
        "FilterRuleInput": {
            "allOf": [
                {
                    "$ref": "#/$defs/Omit_FilterRule.id_"
                },
                {
                    "properties": {
                        "id": {
                            "type": "string"
                        }
                    },
                    "type": "object"
                }
            ],
            "description": "Permissive filter types for chart-as-code uploads where `id` may be omitted.\nFilter IDs are auto-generated during upsert if absent.\nAfter normalization these become the strict runtime types (FilterGroup, Filters)."
        },
        "Filters": {
            "properties": {
                "dimensions": {
                    "$ref": "#/$defs/FilterGroup",
                    "description": "Dimension filter group"
                },
                "metrics": {
                    "$ref": "#/$defs/FilterGroup",
                    "description": "Metric filter group"
                },
                "tableCalculations": {
                    "$ref": "#/$defs/FilterGroup",
                    "description": "Table calculation filter group"
                }
            },
            "type": "object"
        },
        "FiltersInput": {
            "properties": {
                "dimensions": {
                    "$ref": "#/$defs/FilterGroupInput"
                },
                "metrics": {
                    "$ref": "#/$defs/FilterGroupInput"
                },
                "tableCalculations": {
                    "$ref": "#/$defs/FilterGroupInput"
                }
            },
            "type": "object"
        },
        "FixedNumberBinDimension": {
            "additionalProperties": true,
            "properties": {
                "binNumber": {
                    "format": "double",
                    "type": "number"
                },
                "binType": {
                    "$ref": "#/$defs/BinType.FIXED_NUMBER"
                },
                "dimensionId": {
                    "$ref": "#/$defs/FieldId",
                    "description": "Field ID of the parent dimension to bin"
                },
                "id": {
                    "description": "Unique identifier for the custom dimension",
                    "type": "string"
                },
                "name": {
                    "description": "Display name for the custom dimension",
                    "type": "string"
                },
                "table": {
                    "description": "Table this custom dimension belongs to",
                    "type": "string"
                },
                "type": {
                    "$ref": "#/$defs/CustomDimensionType.BIN",
                    "description": "Type of custom dimension (bin or sql)"
                }
            },
            "required": [
                "id",
                "name",
                "table",
                "type",
                "dimensionId",
                "binType",
                "binNumber"
            ],
            "type": "object"
        },
        "FixedWidthBinDimension": {
            "additionalProperties": true,
            "properties": {
                "binType": {
                    "$ref": "#/$defs/BinType.FIXED_WIDTH"
                },
                "binWidth": {
                    "format": "double",
                    "type": "number"
                },
                "dimensionId": {
                    "$ref": "#/$defs/FieldId",
                    "description": "Field ID of the parent dimension to bin"
                },
                "id": {
                    "description": "Unique identifier for the custom dimension",
                    "type": "string"
                },
                "name": {
                    "description": "Display name for the custom dimension",
                    "type": "string"
                },
                "table": {
                    "description": "Table this custom dimension belongs to",
                    "type": "string"
                },
                "type": {
                    "$ref": "#/$defs/CustomDimensionType.BIN",
                    "description": "Type of custom dimension (bin or sql)"
                }
            },
            "required": [
                "id",
                "name",
                "table",
                "type",
                "dimensionId",
                "binType",
                "binWidth"
            ],
            "type": "object"
        },
        "Format": {
            "enum": [
                "km",
                "mi",
                "si",
                "usd",
                "gbp",
                "eur",
                "jpy",
                "dkk",
                "id",
                "percent"
            ],
            "type": "string"
        },
        "FormulaTableCalculation": {
            "allOf": [
                {
                    "$ref": "#/$defs/TableCalculationBase"
                },
                {
                    "properties": {
                        "formula": {
                            "description": "Spreadsheet-like formula compiled to SQL at query time",
                            "type": "string"
                        }
                    },
                    "required": ["formula"],
                    "type": "object"
                }
            ]
        },
        "FrameBoundary": {
            "properties": {
                "offset": {
                    "description": "Offset for PRECEDING/FOLLOWING",
                    "format": "double",
                    "type": "number"
                },
                "type": {
                    "$ref": "#/$defs/FrameBoundaryType",
                    "description": "Boundary type"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "FrameBoundaryType": {
            "enum": [
                "unbounded_preceding",
                "preceding",
                "current_row",
                "following",
                "unbounded_following"
            ],
            "type": "string"
        },
        "FrameClause": {
            "properties": {
                "end": {
                    "$ref": "#/$defs/FrameBoundary",
                    "description": "End boundary of the frame"
                },
                "frameType": {
                    "$ref": "#/$defs/FrameType",
                    "description": "Type of frame (ROWS or RANGE)"
                },
                "start": {
                    "$ref": "#/$defs/FrameBoundary",
                    "description": "Start boundary of the frame"
                }
            },
            "required": ["end", "frameType"],
            "type": "object"
        },
        "FrameType": {
            "enum": ["rows", "range"],
            "type": "string"
        },
        "FunnelChart": {
            "properties": {
                "colorOverrides": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Custom colors for funnel stages"
                },
                "dataInput": {
                    "$ref": "#/$defs/FunnelChartDataInput",
                    "description": "How data is structured (row-based or column-based)"
                },
                "fieldId": {
                    "description": "Field ID to display in funnel",
                    "type": "string"
                },
                "labelOverrides": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Custom labels for funnel stages"
                },
                "labels": {
                    "description": "Label display configuration",
                    "properties": {
                        "position": {
                            "$ref": "#/$defs/FunnelChartLabelPosition",
                            "description": "Position of labels"
                        },
                        "showPercentage": {
                            "description": "Show percentage",
                            "type": "boolean"
                        },
                        "showValue": {
                            "description": "Show the actual value",
                            "type": "boolean"
                        }
                    },
                    "type": "object"
                },
                "legendPosition": {
                    "$ref": "#/$defs/FunnelChartLegendPosition",
                    "description": "Legend orientation"
                },
                "metadata": {
                    "$ref": "#/$defs/Record_string.SeriesMetadata_",
                    "description": "Metadata for series (colors, etc.)"
                },
                "showLegend": {
                    "description": "Show the chart legend",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "FunnelChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/FunnelChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.FUNNEL",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "FunnelChartDataInput": {
            "enum": ["row", "column"],
            "type": "string"
        },
        "FunnelChartLabelPosition": {
            "enum": ["inside", "left", "right", "hidden"],
            "type": "string"
        },
        "FunnelChartLegendPosition": {
            "enum": ["horizontal", "vertical"],
            "type": "string"
        },
        "GaugeChart": {
            "properties": {
                "customLabel": {
                    "description": "Custom label for the gauge value",
                    "type": "string"
                },
                "customPercentageLabel": {
                    "description": "Custom label for the percentage display",
                    "type": "string"
                },
                "max": {
                    "description": "Maximum value for the gauge",
                    "format": "double",
                    "type": "number"
                },
                "maxFieldId": {
                    "description": "Field ID to use as the max value",
                    "type": "string"
                },
                "min": {
                    "description": "Minimum value for the gauge",
                    "format": "double",
                    "type": "number"
                },
                "sections": {
                    "description": "Color sections/ranges for the gauge",
                    "items": {
                        "$ref": "#/$defs/GaugeSection"
                    },
                    "type": "array"
                },
                "selectedField": {
                    "description": "Field ID for the gauge value",
                    "type": "string"
                },
                "showAxisLabels": {
                    "description": "Show min/max labels on the gauge",
                    "type": "boolean"
                },
                "showPercentage": {
                    "description": "Show value as percentage",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "GaugeChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/GaugeChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.GAUGE",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "GaugeSection": {
            "properties": {
                "color": {
                    "description": "Color for this section (hex code)",
                    "type": "string"
                },
                "max": {
                    "description": "End value for this section",
                    "format": "double",
                    "type": "number"
                },
                "maxFieldId": {
                    "description": "Field ID to use as max value",
                    "type": "string"
                },
                "min": {
                    "description": "Start value for this section",
                    "format": "double",
                    "type": "number"
                },
                "minFieldId": {
                    "description": "Field ID to use as min value",
                    "type": "string"
                }
            },
            "required": ["color", "max", "min"],
            "type": "object"
        },
        "GroupValueMatchType": {
            "enum": ["exact", "startsWith", "endsWith", "includes"],
            "type": "string"
        },
        "GroupValueRule": {
            "properties": {
                "matchType": {
                    "$ref": "#/$defs/GroupValueMatchType"
                },
                "value": {
                    "type": "string"
                }
            },
            "required": ["value", "matchType"],
            "type": "object"
        },
        "LegendPlacement": {
            "description": "High-level legend placement preset. Set to 'outsideRight' or 'outsideLeft' to\nrender the legend beside the plot with reserved grid space. Undefined behaves\nlike 'custom' (no override of the existing legend position fields).",
            "enum": ["custom", "outsideRight", "outsideLeft"],
            "type": "string"
        },
        "MapChart": {
            "properties": {
                "backgroundColor": {
                    "description": "Background color for the map (hex code)",
                    "type": "string"
                },
                "colorOverrides": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Per-value color overrides for categorical color fields"
                },
                "colorRange": {
                    "description": "Array of colors for the value gradient",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "customGeoJsonUrl": {
                    "description": "URL to custom GeoJSON file",
                    "type": "string"
                },
                "darkModeTileBackground": {
                    "$ref": "#/$defs/MapTileBackground",
                    "description": "Map tile background style for dark mode (uses dark default when undefined)"
                },
                "dataLayerOpacity": {
                    "description": "Data layer opacity (0.1 to 1)",
                    "format": "double",
                    "type": "number"
                },
                "defaultCenterLat": {
                    "description": "Default center latitude",
                    "format": "double",
                    "type": "number"
                },
                "defaultCenterLon": {
                    "description": "Default center longitude",
                    "format": "double",
                    "type": "number"
                },
                "defaultZoom": {
                    "description": "Default zoom level",
                    "format": "double",
                    "type": "number"
                },
                "fieldConfig": {
                    "$ref": "#/$defs/Record_string.MapFieldConfig_",
                    "description": "Field-specific configuration for tooltips"
                },
                "geoJsonPropertyKey": {
                    "description": "Property key in GeoJSON to match against data",
                    "type": "string"
                },
                "heatmapConfig": {
                    "description": "Configuration for heatmap visualization",
                    "properties": {
                        "blur": {
                            "description": "Blur amount for heat points",
                            "format": "double",
                            "type": "number"
                        },
                        "opacity": {
                            "description": "Opacity of the heatmap layer",
                            "format": "double",
                            "type": "number"
                        },
                        "radius": {
                            "description": "Radius of heat points",
                            "format": "double",
                            "type": "number"
                        }
                    },
                    "type": "object"
                },
                "hexbinConfig": {
                    "description": "Configuration for H3 hexagonal binning visualization",
                    "properties": {
                        "aggregation": {
                            "$ref": "#/$defs/MapHexbinAggregation",
                            "description": "Aggregation applied when valueBasis = FIELD. Defaults to SUM."
                        },
                        "emptyBinColor": {
                            "description": "Fill color for empty bins. Hex6 (#rrggbb) = solid fill, hex8\n(#rrggbbaa) = fill with alpha, null/undefined = outline only.",
                            "type": ["string", "null"]
                        },
                        "fixedResolution": {
                            "description": "H3 resolution (0-15) used when sizingMode is FIXED. Ignored otherwise.",
                            "format": "double",
                            "type": "number"
                        },
                        "opacity": {
                            "description": "Opacity of hex polygons (0.1 to 1)",
                            "format": "double",
                            "type": "number"
                        },
                        "showEmptyBins": {
                            "description": "Render outlined empty cells across the visible map area, so the user\ncan see \"where there is no data\" relative to the hex grid.",
                            "type": "boolean"
                        },
                        "sizingMode": {
                            "$ref": "#/$defs/MapHexbinSizingMode",
                            "description": "How bin size is determined. Defaults to DYNAMIC if unset."
                        },
                        "valueBasis": {
                            "$ref": "#/$defs/MapHexbinValueBasis",
                            "description": "What drives cell color: count of points (default) or an aggregation\nover a chosen value field (controlled via the chart's `valueFieldId`)."
                        }
                    },
                    "type": "object"
                },
                "latitudeFieldId": {
                    "description": "Field ID for latitude values",
                    "type": "string"
                },
                "locationFieldId": {
                    "description": "Field ID for location/region names (area maps)",
                    "type": "string"
                },
                "locationType": {
                    "$ref": "#/$defs/MapChartType",
                    "description": "How to display location data"
                },
                "longitudeFieldId": {
                    "description": "Field ID for longitude values",
                    "type": "string"
                },
                "mapType": {
                    "$ref": "#/$defs/MapChartLocation",
                    "description": "Type of map to display"
                },
                "maxBubbleSize": {
                    "description": "Maximum bubble size for scatter maps",
                    "format": "double",
                    "type": "number"
                },
                "minBubbleSize": {
                    "description": "Minimum bubble size for scatter maps",
                    "format": "double",
                    "type": "number"
                },
                "noDataColor": {
                    "description": "Color for regions with no data (hex code)",
                    "type": "string"
                },
                "saveMapExtent": {
                    "description": "Save the current map zoom/position",
                    "type": "boolean"
                },
                "showLegend": {
                    "description": "Show the map legend",
                    "type": "boolean"
                },
                "sizeFieldId": {
                    "description": "Field ID for bubble size (scatter maps)",
                    "type": "string"
                },
                "tileBackground": {
                    "$ref": "#/$defs/MapTileBackground",
                    "description": "Map tile background style"
                },
                "valueFieldId": {
                    "description": "Field ID for the value to display",
                    "type": "string"
                }
            },
            "type": "object"
        },
        "MapChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/MapChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.MAP",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "MapChartLocation": {
            "enum": ["USA", "world", "europe", "custom"],
            "type": "string"
        },
        "MapChartType": {
            "enum": ["scatter", "area", "heatmap", "hexbin"],
            "type": "string"
        },
        "MapFieldConfig": {
            "properties": {
                "label": {
                    "description": "Custom label for the field",
                    "type": "string"
                },
                "visible": {
                    "description": "Whether to show this field in tooltips",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "MapHexbinAggregation": {
            "enum": ["sum", "avg", "min", "max"],
            "type": "string"
        },
        "MapHexbinSizingMode": {
            "enum": ["dynamic", "fixed"],
            "type": "string"
        },
        "MapHexbinValueBasis": {
            "enum": ["count", "field"],
            "type": "string"
        },
        "MapTileBackground": {
            "enum": [
                "none",
                "openstreetmap",
                "light",
                "dark",
                "satellite",
                "voyager"
            ],
            "type": "string"
        },
        "MarkLine": {
            "properties": {
                "data": {
                    "description": "Reference line data points",
                    "items": {
                        "$ref": "#/$defs/MarkLineData"
                    },
                    "type": "array"
                },
                "label": {
                    "description": "Label configuration",
                    "properties": {
                        "formatter": {
                            "description": "Label formatter",
                            "type": "string"
                        }
                    },
                    "type": "object"
                },
                "lineStyle": {
                    "description": "Line style configuration",
                    "properties": {
                        "color": {
                            "description": "Line color",
                            "type": "string"
                        },
                        "type": {
                            "description": "Line type",
                            "type": "string"
                        },
                        "width": {
                            "description": "Line width",
                            "format": "double",
                            "type": "number"
                        }
                    },
                    "required": ["type", "width", "color"],
                    "type": "object"
                },
                "symbol": {
                    "description": "Symbol at line endpoints",
                    "type": "string"
                }
            },
            "required": ["data"],
            "type": "object"
        },
        "MarkLineData": {
            "properties": {
                "dynamicValue": {
                    "description": "Dynamic value type",
                    "enum": ["average"],
                    "type": "string"
                },
                "label": {
                    "description": "Label configuration for this data point",
                    "properties": {
                        "formatter": {
                            "description": "Label formatter",
                            "type": "string"
                        },
                        "position": {
                            "description": "Label position",
                            "enum": ["start", "middle", "end"],
                            "type": "string"
                        }
                    },
                    "type": "object"
                },
                "lineStyle": {
                    "description": "Line style for this data point",
                    "properties": {
                        "color": {
                            "description": "Line color",
                            "type": "string"
                        }
                    },
                    "required": ["color"],
                    "type": "object"
                },
                "name": {
                    "description": "Name of the reference line",
                    "type": "string"
                },
                "type": {
                    "description": "Point type (e.g., 'average')",
                    "type": "string"
                },
                "uuid": {
                    "description": "Unique identifier for this mark line",
                    "type": "string"
                },
                "value": {
                    "description": "Value to display",
                    "type": "string"
                },
                "xAxis": {
                    "description": "X axis value for vertical line",
                    "type": "string"
                },
                "yAxis": {
                    "description": "Y axis value for horizontal line",
                    "type": "string"
                }
            },
            "required": ["uuid"],
            "type": "object"
        },
        "MergeJoinKeyPart": {
            "description": "One column of the join key. Sources name the same real-world key differently\n(`orders.order_date` vs `users.created_date`), so the mapping is explicit per\nsource rather than positional.",
            "properties": {
                "fieldIdBySourceId": {
                    "$ref": "#/$defs/Record_string.FieldId_",
                    "description": "The field each source joins on. Every source must have an entry."
                },
                "name": {
                    "description": "Column name this key part takes in the merged result.",
                    "type": "string"
                }
            },
            "required": ["fieldIdBySourceId", "name"],
            "type": "object"
        },
        "MergeJoinType": {
            "description": "How unmatched keys survive the merge. Mirrors the SQL join it compiles to.",
            "enum": ["full", "left", "inner"],
            "type": "string"
        },
        "MergeTableCalculation": {
            "description": "A calculation over the *merged* result, where a row-wise calculation across\nsource queries can correctly live. Formula references use merged field ids;\nlegacy SQL references use `${sourceId.fieldId}`.",
            "properties": {
                "displayName": {
                    "type": "string"
                },
                "format": {
                    "$ref": "#/$defs/CustomFormat",
                    "description": "How the calculation's values are displayed."
                },
                "formula": {
                    "description": "Spreadsheet-like formula over merged field ids.",
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "sql": {
                    "description": "Legacy SQL expression. Kept required for API/storage compatibility;\nformula calculations store an empty string here and compile `formula`\non the compose engine instead.",
                    "type": "string"
                }
            },
            "required": ["sql", "displayName", "name"],
            "type": "object"
        },
        "MetricFilterRule": {
            "additionalProperties": true,
            "description": "Filter rule for metrics, targeting fields by reference",
            "properties": {
                "caseSensitive": {
                    "description": "Overrides the field/explore case-sensitivity for this rule only.\nUsed by internal features like autocomplete search that must always\nmatch case-insensitively regardless of the field's configured setting.",
                    "type": "boolean"
                },
                "disabled": {
                    "description": "Whether this filter is disabled",
                    "type": "boolean"
                },
                "id": {
                    "description": "Unique identifier for the filter",
                    "type": "string"
                },
                "includeNull": {
                    "description": "For the `equals` operator on string fields, also match rows where the\nfield is null (compiles to `field IN (...) OR field IS NULL`). Lets users\ncombine null with selected values in a single \"is\" rule.",
                    "type": "boolean"
                },
                "operator": {
                    "$ref": "#/$defs/FilterOperator",
                    "description": "Filter operator"
                },
                "required": {
                    "description": "Whether this filter is required",
                    "type": "boolean"
                },
                "settings": {
                    "$ref": "#/$defs/AnyType",
                    "description": "Additional settings for date/time filters"
                },
                "target": {
                    "description": "Target field for the filter",
                    "properties": {
                        "fieldRef": {
                            "description": "Field reference to filter on (e.g., 'table_name.field_name')",
                            "type": "string"
                        }
                    },
                    "required": ["fieldRef"],
                    "type": "object"
                },
                "values": {
                    "description": "Values to filter by",
                    "items": {
                        "$ref": "#/$defs/AnyType"
                    },
                    "type": "array"
                }
            },
            "required": ["operator", "id", "target"],
            "type": "object"
        },
        "MetricOverrides": {
            "additionalProperties": {
                "$ref": "#/$defs/Pick_Metric.formatOptions_"
            },
            "properties": {},
            "type": "object"
        },
        "MetricQuery": {
            "properties": {
                "additionalMetrics": {
                    "description": "Custom metrics defined inline (ad-hoc metrics not in the dbt model)",
                    "items": {
                        "$ref": "#/$defs/AdditionalMetric"
                    },
                    "type": "array"
                },
                "customDimensions": {
                    "description": "Custom dimensions defined inline",
                    "items": {
                        "$ref": "#/$defs/CustomDimension"
                    },
                    "type": "array"
                },
                "dimensionOverrides": {
                    "$ref": "#/$defs/DimensionOverrides",
                    "description": "Override formatting options for existing dimensions"
                },
                "dimensions": {
                    "description": "List of dimension field IDs to include",
                    "items": {
                        "$ref": "#/$defs/FieldId"
                    },
                    "type": "array"
                },
                "exploreName": {
                    "description": "The name of the explore to query",
                    "type": "string"
                },
                "filters": {
                    "$ref": "#/$defs/Filters",
                    "description": "Filter rules to apply to the query"
                },
                "limit": {
                    "description": "Maximum number of rows to return",
                    "format": "double",
                    "type": "number"
                },
                "metadata": {
                    "properties": {
                        "hasADateDimension": {
                            "$ref": "#/$defs/Pick_CompiledDimension.label-or-name-or-table_"
                        }
                    },
                    "required": ["hasADateDimension"],
                    "type": "object"
                },
                "metricOverrides": {
                    "$ref": "#/$defs/MetricOverrides",
                    "description": "Override formatting options for existing metrics"
                },
                "metrics": {
                    "description": "List of metric field IDs to include",
                    "items": {
                        "$ref": "#/$defs/FieldId"
                    },
                    "type": "array"
                },
                "pivotDimensions": {
                    "description": "Dimension field IDs used as pivot columns (from chart's pivotConfig.columns).\nUsed by row_total() to determine non-pivot dimensions for GROUP BY.",
                    "items": {
                        "$ref": "#/$defs/FieldId"
                    },
                    "type": "array"
                },
                "sorts": {
                    "description": "Sort configuration for query results",
                    "items": {
                        "$ref": "#/$defs/SortField"
                    },
                    "type": "array"
                },
                "tableCalculations": {
                    "description": "Custom calculations to perform on query results",
                    "items": {
                        "$ref": "#/$defs/TableCalculation"
                    },
                    "type": "array"
                },
                "timezone": {
                    "description": "Timezone for date/time values (e.g., 'America/Los_Angeles', 'UTC')",
                    "type": "string"
                }
            },
            "required": [
                "tableCalculations",
                "limit",
                "sorts",
                "filters",
                "metrics",
                "dimensions",
                "exploreName"
            ],
            "type": "object"
        },
        "MetricType": {
            "enum": [
                "percentile",
                "average",
                "count",
                "count_distinct",
                "sum",
                "sum_distinct",
                "average_distinct",
                "min",
                "max",
                "percent_of_previous",
                "percent_of_total",
                "running_total",
                "number",
                "median",
                "string",
                "date",
                "timestamp",
                "boolean"
            ],
            "type": "string"
        },
        "NumberSeparator": {
            "enum": [
                "default",
                "commaPeriod",
                "spacePeriod",
                "periodComma",
                "noSeparatorPeriod",
                "apostrophePeriod"
            ],
            "type": "string"
        },
        "Omit_DataAppVizChart.dataAppVizUuid-or-dataAppVizVersion_": {
            "$ref": "#/$defs/Pick_DataAppVizChart.Exclude_keyofDataAppVizChart.dataAppVizUuid-or-dataAppVizVersion__",
            "description": "Construct a type with the properties of T except for those in type K."
        },
        "Omit_FilterRule.id_": {
            "$ref": "#/$defs/Pick_FilterRule.Exclude_keyofFilterRule.id__",
            "description": "Construct a type with the properties of T except for those in type K."
        },
        "Omit_MetricQuery.filters_": {
            "$ref": "#/$defs/Pick_MetricQuery.Exclude_keyofMetricQuery.filters__",
            "description": "Construct a type with the properties of T except for those in type K."
        },
        "OrFilterGroup": {
            "properties": {
                "id": {
                    "description": "Unique identifier for the filter group",
                    "type": "string"
                },
                "or": {
                    "description": "Array of filters or nested groups combined with OR logic",
                    "items": {
                        "$ref": "#/$defs/FilterGroupItem"
                    },
                    "type": "array"
                }
            },
            "required": ["or", "id"],
            "type": "object"
        },
        "OrFilterGroupInput": {
            "properties": {
                "id": {
                    "type": "string"
                },
                "or": {
                    "items": {
                        "$ref": "#/$defs/FilterGroupItemInput"
                    },
                    "type": "array"
                }
            },
            "required": ["or"],
            "type": "object"
        },
        "ParametersValuesMap": {
            "$ref": "#/$defs/Record_string.ParameterValue_"
        },
        "ParameterValue": {
            "anyOf": [
                {
                    "type": "string"
                },
                {
                    "format": "double",
                    "type": "number"
                },
                {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                {
                    "items": {
                        "format": "double",
                        "type": "number"
                    },
                    "type": "array"
                }
            ]
        },
        "Partial_CompleteCartesianChartLayout_": {
            "description": "Make all properties in T optional",
            "properties": {
                "categoryColorOverrides": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Per-category color overrides (maps category value to hex color)"
                },
                "colorByCategory": {
                    "description": "Color each bar by its category value instead of using a single series color",
                    "type": "boolean"
                },
                "connectNulls": {
                    "description": "Connect null data points with a line",
                    "type": "boolean"
                },
                "flipAxes": {
                    "description": "Swap X and Y axes (creates horizontal bar charts)",
                    "type": "boolean"
                },
                "showGridX": {
                    "description": "Show vertical grid lines",
                    "type": "boolean"
                },
                "showGridY": {
                    "description": "Show horizontal grid lines",
                    "type": "boolean"
                },
                "showIncompletePeriod": {
                    "description": "If true, marks the unfinished current period (for example, this week) with a dashed line segment and hatched bars.",
                    "type": "boolean"
                },
                "showLeftYAxis": {
                    "description": "Controls left/primary Y-axis visibility",
                    "type": "boolean"
                },
                "showRightYAxis": {
                    "description": "Controls right/secondary Y-axis visibility",
                    "type": "boolean"
                },
                "showXAxis": {
                    "description": "Show the X axis",
                    "type": "boolean"
                },
                "showYAxis": {
                    "description": "Show the Y axis",
                    "type": "boolean"
                },
                "stack": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "boolean"
                        }
                    ],
                    "description": "Stack series together (true for default stacking, or string for stack group name)"
                },
                "xField": {
                    "description": "Field ID to use for the X axis",
                    "type": "string"
                },
                "yField": {
                    "description": "Field IDs to use for the Y axis",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "Partial_CompleteEChartsConfig_": {
            "description": "Make all properties in T optional",
            "properties": {
                "axisLabelFontSize": {
                    "description": "Font size for axis labels",
                    "format": "double",
                    "type": "number"
                },
                "axisTitleFontSize": {
                    "description": "Font size for axis titles",
                    "format": "double",
                    "type": "number"
                },
                "grid": {
                    "$ref": "#/$defs/EchartsGrid",
                    "description": "Grid (chart area) configuration"
                },
                "legend": {
                    "$ref": "#/$defs/EchartsLegend",
                    "description": "Legend configuration"
                },
                "series": {
                    "description": "Chart series configuration",
                    "items": {
                        "$ref": "#/$defs/Series"
                    },
                    "type": "array"
                },
                "showAxisTicks": {
                    "description": "Show tick marks on axes",
                    "type": "boolean"
                },
                "stackGroupLabelContent": {
                    "description": "What the label over a named stack shows: its label, the stack total\nonly, or both (default) (PRpillar fork: grouped stacked bars)",
                    "enum": ["label", "total", "both"],
                    "type": "string"
                },
                "stackGroupLabelRotate": {
                    "description": "Stack label angle on vertical bars: 0 (default, horizontal, fitted\nto the bar) or 90 (PRpillar fork: grouped stacked bars)",
                    "format": "double",
                    "type": "number"
                },
                "stackGroupLabels": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Stack name -> label. Named stacks get a label over each bar and their\nown block in the tooltip (PRpillar fork: grouped stacked bars)"
                },
                "stackGroupShortLabels": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Stack name -> short label, used over narrow bars instead of the\nstackGroupLabels one (PRpillar fork: grouped stacked bars)"
                },
                "tooltip": {
                    "description": "Tooltip formatter template",
                    "type": "string"
                },
                "tooltipSort": {
                    "$ref": "#/$defs/TooltipSortBy",
                    "description": "How to sort tooltip items"
                },
                "xAxis": {
                    "description": "X axis configuration",
                    "items": {
                        "$ref": "#/$defs/XAxis"
                    },
                    "type": "array"
                },
                "yAxis": {
                    "description": "Y axis configuration",
                    "items": {
                        "$ref": "#/$defs/Axis"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "Partial_PieChartValueOptions_": {
            "description": "Make all properties in T optional",
            "properties": {
                "showPercentage": {
                    "type": "boolean"
                },
                "showValue": {
                    "type": "boolean"
                },
                "valueLabel": {
                    "enum": ["hidden", "inside", "outside"],
                    "type": "string"
                },
                "valueLabelColor": {
                    "type": "string"
                }
            },
            "type": "object"
        },
        "Pick_CompiledDimension.label-or-name-or-table_": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {
                "label": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "table": {
                    "type": "string"
                }
            },
            "required": ["name", "label", "table"],
            "type": "object"
        },
        "Pick_CompiledDimension.name-or-label-or-table_": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {},
            "type": "object"
        },
        "Pick_DataAppVizChart.Exclude_keyofDataAppVizChart.dataAppVizUuid-or-dataAppVizVersion__": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {
                "fieldMapping": {
                    "$ref": "#/$defs/DataAppVizFieldMapping"
                },
                "optionValues": {
                    "$ref": "#/$defs/DataAppVizOptionValues",
                    "description": "Only options the user explicitly changed — declared defaults are never\nseeded here, they're resolved at render time. Absent on charts saved\nbefore config options shipped."
                }
            },
            "required": ["fieldMapping"],
            "type": "object"
        },
        "Pick_Dimension.formatOptions_": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {
                "formatOptions": {
                    "$ref": "#/$defs/CustomFormat"
                }
            },
            "type": "object"
        },
        "Pick_FilterRule.Exclude_keyofFilterRule.id__": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {
                "caseSensitive": {
                    "description": "Overrides the field/explore case-sensitivity for this rule only.\nUsed by internal features like autocomplete search that must always\nmatch case-insensitively regardless of the field's configured setting.",
                    "type": "boolean"
                },
                "disabled": {
                    "description": "Whether this filter is disabled",
                    "type": "boolean"
                },
                "includeNull": {
                    "description": "For the `equals` operator on string fields, also match rows where the\nfield is null (compiles to `field IN (...) OR field IS NULL`). Lets users\ncombine null with selected values in a single \"is\" rule.",
                    "type": "boolean"
                },
                "operator": {
                    "$ref": "#/$defs/FilterOperator",
                    "description": "Filter operator"
                },
                "required": {
                    "description": "Whether this filter is required",
                    "type": "boolean"
                },
                "settings": {
                    "description": "Additional settings for date/time filters"
                },
                "target": {
                    "$ref": "#/$defs/FieldTarget",
                    "description": "Target field for the filter"
                },
                "values": {
                    "description": "Values to filter by",
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["target", "operator"],
            "type": "object"
        },
        "Pick_Metric.formatOptions_": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {
                "formatOptions": {
                    "$ref": "#/$defs/CustomFormat"
                }
            },
            "type": "object"
        },
        "Pick_MetricQuery.Exclude_keyofMetricQuery.filters__": {
            "description": "From T, pick a set of properties whose keys are in the union K",
            "properties": {
                "additionalMetrics": {
                    "description": "Custom metrics defined inline (ad-hoc metrics not in the dbt model)",
                    "items": {
                        "$ref": "#/$defs/AdditionalMetric"
                    },
                    "type": "array"
                },
                "customDimensions": {
                    "description": "Custom dimensions defined inline",
                    "items": {
                        "$ref": "#/$defs/CustomDimension"
                    },
                    "type": "array"
                },
                "dimensionOverrides": {
                    "$ref": "#/$defs/DimensionOverrides",
                    "description": "Override formatting options for existing dimensions"
                },
                "dimensions": {
                    "description": "List of dimension field IDs to include",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "exploreName": {
                    "description": "The name of the explore to query",
                    "type": "string"
                },
                "limit": {
                    "description": "Maximum number of rows to return",
                    "format": "double",
                    "type": "number"
                },
                "metadata": {
                    "properties": {
                        "hasADateDimension": {
                            "$ref": "#/$defs/Pick_CompiledDimension.name-or-label-or-table_"
                        }
                    },
                    "required": ["hasADateDimension"],
                    "type": "object"
                },
                "metricOverrides": {
                    "$ref": "#/$defs/MetricOverrides",
                    "description": "Override formatting options for existing metrics"
                },
                "metrics": {
                    "description": "List of metric field IDs to include",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "pivotDimensions": {
                    "description": "Dimension field IDs used as pivot columns (from chart's pivotConfig.columns).\nUsed by row_total() to determine non-pivot dimensions for GROUP BY.",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "sorts": {
                    "description": "Sort configuration for query results",
                    "items": {
                        "$ref": "#/$defs/SortField"
                    },
                    "type": "array"
                },
                "tableCalculations": {
                    "description": "Custom calculations to perform on query results",
                    "items": {
                        "$ref": "#/$defs/TableCalculation"
                    },
                    "type": "array"
                },
                "timezone": {
                    "description": "Timezone for date/time values (e.g., 'America/Los_Angeles', 'UTC')",
                    "type": "string"
                }
            },
            "required": [
                "metrics",
                "limit",
                "exploreName",
                "dimensions",
                "sorts",
                "tableCalculations"
            ],
            "type": "object"
        },
        "PieChart": {
            "properties": {
                "groupColorOverrides": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Custom colors for each group/slice"
                },
                "groupFieldIds": {
                    "description": "Field IDs used for grouping/slicing the pie",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "groupLabelOverrides": {
                    "$ref": "#/$defs/Record_string.string_",
                    "description": "Custom labels for each group/slice"
                },
                "groupSortOverrides": {
                    "description": "Custom sort order for groups/slices",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "groupValueOptionOverrides": {
                    "$ref": "#/$defs/Record_string.Partial_PieChartValueOptions__",
                    "description": "Per-slice value display options"
                },
                "isDonut": {
                    "description": "Display as donut chart with hole in center",
                    "type": "boolean"
                },
                "legendMaxItemLength": {
                    "description": "Maximum character length for legend items",
                    "format": "double",
                    "type": "number"
                },
                "legendPosition": {
                    "$ref": "#/$defs/PieChartLegendPosition",
                    "description": "Legend position/orientation"
                },
                "metadata": {
                    "$ref": "#/$defs/Record_string.SeriesMetadata_",
                    "description": "Metadata for series (colors, etc.)"
                },
                "metricId": {
                    "description": "Field ID of the metric to display",
                    "type": "string"
                },
                "showLegend": {
                    "description": "Show the chart legend",
                    "type": "boolean"
                },
                "showPercentage": {
                    "description": "Show percentage on slices",
                    "type": "boolean"
                },
                "showValue": {
                    "description": "Show the actual value on slices",
                    "type": "boolean"
                },
                "valueLabel": {
                    "$ref": "#/$defs/PieChartValueLabel",
                    "description": "Position of value labels on slices"
                },
                "valueLabelColor": {
                    "description": "Custom color for value labels",
                    "type": "string"
                }
            },
            "type": "object"
        },
        "PieChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/PieChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.PIE",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "PieChartLegendPosition": {
            "enum": ["horizontal", "vertical"],
            "type": "string"
        },
        "PieChartValueLabel": {
            "enum": ["hidden", "inside", "outside"],
            "type": "string"
        },
        "PivotChartLayout": {
            "properties": {
                "groupBy": {
                    "items": {
                        "properties": {
                            "reference": {
                                "type": "string"
                            }
                        },
                        "required": ["reference"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "sortBy": {
                    "items": {
                        "$ref": "#/$defs/VizSortBy"
                    },
                    "type": "array"
                },
                "stack": {
                    "anyOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "$ref": "#/$defs/StackType"
                        }
                    ]
                },
                "x": {
                    "properties": {
                        "reference": {
                            "type": "string"
                        },
                        "type": {
                            "$ref": "#/$defs/VizIndexType"
                        }
                    },
                    "required": ["type", "reference"],
                    "type": "object"
                },
                "y": {
                    "items": {
                        "properties": {
                            "aggregation": {
                                "$ref": "#/$defs/VizAggregationOptions"
                            },
                            "reference": {
                                "type": "string"
                            }
                        },
                        "required": ["aggregation", "reference"],
                        "type": "object"
                    },
                    "type": "array"
                }
            },
            "required": ["y"],
            "type": "object"
        },
        "PivotReference": {
            "properties": {
                "field": {
                    "description": "Field ID being referenced",
                    "type": "string"
                },
                "pivotValues": {
                    "description": "Pivot values for this reference (for pivoted data)",
                    "items": {
                        "$ref": "#/$defs/PivotValue"
                    },
                    "type": "array"
                }
            },
            "required": ["field"],
            "type": "object"
        },
        "PivotSortAnchor": {
            "description": "Coordinates of a single pivot column, used to anchor a row sort to that\nspecific column when results are pivoted.",
            "properties": {
                "reference": {
                    "type": "string"
                },
                "value": {
                    "anyOf": [
                        {
                            "anyOf": [
                                {
                                    "type": "string"
                                },
                                {
                                    "format": "double",
                                    "type": "number"
                                },
                                {
                                    "type": "boolean"
                                }
                            ]
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "required": ["value", "reference"],
            "type": "object"
        },
        "PivotValue": {
            "properties": {
                "field": {
                    "description": "Pivot field ID",
                    "type": "string"
                },
                "value": {
                    "description": "Pivot value"
                }
            },
            "required": ["value", "field"],
            "type": "object"
        },
        "Record_string.boolean_": {
            "additionalProperties": {
                "type": "boolean"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.ColumnProperties_": {
            "additionalProperties": {
                "$ref": "#/$defs/ColumnProperties"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.DataAppVizOptionValue_": {
            "additionalProperties": {
                "$ref": "#/$defs/DataAppVizOptionValue"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.FieldId_": {
            "additionalProperties": {
                "type": "string"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.MapFieldConfig_": {
            "additionalProperties": {
                "$ref": "#/$defs/MapFieldConfig"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.ParameterValue_": {
            "additionalProperties": {
                "$ref": "#/$defs/ParameterValue"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.Partial_PieChartValueOptions__": {
            "additionalProperties": {
                "$ref": "#/$defs/Partial_PieChartValueOptions_"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.SeriesMetadata_": {
            "additionalProperties": {
                "$ref": "#/$defs/SeriesMetadata"
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.string_": {
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.string-or-string-Array_": {
            "additionalProperties": {
                "anyOf": [
                    {
                        "type": "string"
                    },
                    {
                        "items": {
                            "type": "string"
                        },
                        "type": "array"
                    }
                ]
            },
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "Record_string.unknown_": {
            "additionalProperties": {},
            "description": "Construct a type with a set of properties K of type T",
            "properties": {},
            "type": "object"
        },
        "RowLimit": {
            "properties": {
                "count": {
                    "description": "Number of rows to show or hide",
                    "format": "double",
                    "type": "number"
                },
                "direction": {
                    "description": "Whether to target the first or last N rows",
                    "enum": ["first", "last"],
                    "type": "string"
                },
                "mode": {
                    "description": "Whether to show or hide the selected rows",
                    "enum": ["show", "hide"],
                    "type": "string"
                }
            },
            "required": ["count", "direction", "mode"],
            "type": "object"
        },
        "SankeyChart": {
            "properties": {
                "metricFieldId": {
                    "description": "Field ID for the link value metric",
                    "type": "string"
                },
                "nodeAlign": {
                    "description": "Node alignment",
                    "enum": ["left", "right", "justify"],
                    "type": "string"
                },
                "nodeLayout": {
                    "$ref": "#/$defs/SankeyNodeLayout",
                    "description": "How nodes are laid out across steps"
                },
                "orient": {
                    "description": "Orientation of the diagram",
                    "enum": ["horizontal", "vertical"],
                    "type": "string"
                },
                "sourceFieldId": {
                    "description": "Field ID for the source node dimension",
                    "type": "string"
                },
                "targetFieldId": {
                    "description": "Field ID for the target node dimension",
                    "type": "string"
                }
            },
            "type": "object"
        },
        "SankeyChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/SankeyChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.SANKEY",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "SankeyNodeLayout": {
            "description": "How nodes are laid out:\n- `multi-step`: depth-unrolled journeys (default)\n- `merged`: one node per label, journeys preserved (acyclic flows only)\n- `direct`: two-column source→target pairs, no chaining",
            "enum": ["multi-step", "merged", "direct"],
            "type": "string"
        },
        "SavedMergeDefinition": {
            "properties": {
                "chartAs": {
                    "description": "The chart query's name in merged column ids, when not its explore's.",
                    "type": "string"
                },
                "chartRepeats": {
                    "description": "The chart's own query repeats its values. Omitted when off.",
                    "type": "boolean"
                },
                "join": {
                    "$ref": "#/$defs/MergeJoinType"
                },
                "keyNames": {
                    "additionalProperties": {
                        "type": "string"
                    },
                    "description": "The key column's name, when not the chart field's id.",
                    "properties": {},
                    "type": "object"
                },
                "keys": {
                    "additionalProperties": {
                        "items": {
                            "type": "string"
                        },
                        "type": "array"
                    },
                    "description": "The join keys: each entry is the chart's field and one `query.fieldId`\nreference per other query. The key column takes the chart field's id.",
                    "properties": {},
                    "type": "object"
                },
                "limit": {
                    "format": "double",
                    "type": "number"
                },
                "queries": {
                    "additionalProperties": {
                        "$ref": "#/$defs/SavedMergeDefinitionQuery"
                    },
                    "description": "The other queries, by the name they go by.",
                    "properties": {},
                    "type": "object"
                },
                "sort": {
                    "items": {
                        "$ref": "#/$defs/SavedMergeDefinitionSort"
                    },
                    "type": "array"
                },
                "tableCalculations": {
                    "items": {
                        "$ref": "#/$defs/MergeTableCalculation"
                    },
                    "type": "array"
                }
            },
            "required": ["limit", "keys", "join", "queries"],
            "type": "object"
        },
        "SavedMergeDefinitionQuery": {
            "description": "A query the merge owns, run against an explore.",
            "properties": {
                "additionalMetrics": {
                    "items": {
                        "$ref": "#/$defs/AdditionalMetric"
                    },
                    "type": "array"
                },
                "customDimensions": {
                    "items": {
                        "$ref": "#/$defs/CustomDimension"
                    },
                    "type": "array"
                },
                "dimensionOverrides": {
                    "$ref": "#/$defs/DimensionOverrides"
                },
                "dimensions": {
                    "items": {
                        "$ref": "#/$defs/FieldId"
                    },
                    "type": "array"
                },
                "explore": {
                    "type": "string"
                },
                "filters": {
                    "$ref": "#/$defs/Filters"
                },
                "metricOverrides": {
                    "$ref": "#/$defs/MetricOverrides"
                },
                "metrics": {
                    "items": {
                        "$ref": "#/$defs/FieldId"
                    },
                    "type": "array"
                },
                "repeat": {
                    "description": "See MergeQueryMetricSource.repeatValues. Omitted when off.",
                    "type": "boolean"
                },
                "tableCalculations": {
                    "items": {
                        "$ref": "#/$defs/TableCalculation"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                }
            },
            "required": ["metrics", "dimensions", "explore"],
            "type": "object"
        },
        "SavedMergeDefinitionSort": {
            "description": "A sort of the merged result. `by` is a chart field id, a `query.fieldId`\nreference into another query, or the name of a merge table calculation.\nA chart field that is a join key sorts the key column.",
            "properties": {
                "by": {
                    "type": "string"
                },
                "direction": {
                    "$ref": "#/$defs/SavedMergeDefinitionSortDirection"
                }
            },
            "required": ["direction", "by"],
            "type": "object"
        },
        "SavedMergeDefinitionSortDirection": {
            "enum": ["asc", "desc"],
            "type": "string"
        },
        "SavedMergeQuery": {
            "description": "Schema v2 of a merge stored on a chart version. Accepted on requests and\nread from rows written before schema v3; rewritten to schema v3 by\nupgradeSavedMergeQuery. Never written.",
            "properties": {
                "joinKey": {
                    "items": {
                        "$ref": "#/$defs/MergeJoinKeyPart"
                    },
                    "type": "array"
                },
                "joinType": {
                    "$ref": "#/$defs/MergeJoinType"
                },
                "primarySourceId": {
                    "description": "Source whose rows a LEFT merge preserves.",
                    "type": "string"
                },
                "repeatValuesSourceIds": {
                    "description": "Sources that repeat their values across the other sources' extra\ndimensions (MergeQueryMetricSource.repeatValues). Kept on the merge,\nnot the source, so the source shapes stay as they were saved.\nOmitted when none repeat.",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "sources": {
                    "items": {
                        "$ref": "#/$defs/SavedMergeQuerySource"
                    },
                    "type": "array"
                },
                "tableCalculations": {
                    "items": {
                        "$ref": "#/$defs/MergeTableCalculation"
                    },
                    "type": "array"
                }
            },
            "required": [
                "tableCalculations",
                "joinType",
                "joinKey",
                "sources",
                "primarySourceId"
            ],
            "type": "object"
        },
        "SavedMergeQuerySource": {
            "anyOf": [
                {
                    "properties": {
                        "id": {
                            "type": "string"
                        },
                        "kind": {
                            "enum": ["chart"],
                            "type": "string"
                        }
                    },
                    "required": ["kind", "id"],
                    "type": "object"
                },
                {
                    "properties": {
                        "id": {
                            "type": "string"
                        },
                        "kind": {
                            "enum": ["query"],
                            "type": "string"
                        },
                        "metricQuery": {
                            "$ref": "#/$defs/MetricQuery"
                        }
                    },
                    "required": ["metricQuery", "kind", "id"],
                    "type": "object"
                }
            ],
            "description": "A persisted merge source.\n\nThe chart source is a reference: its metric query already lives on the chart\nversion. Every additional source owns its query. This keeps one source of\ntruth while allowing more sources without adding `thirdQuery`, `fourthQuery`,\nand so on."
        },
        "Series": {
            "properties": {
                "areaStyle": {
                    "$ref": "#/$defs/Record_string.unknown_",
                    "description": "Area fill style (presence indicates area chart)"
                },
                "color": {
                    "description": "Color for the series (hex code)",
                    "type": "string"
                },
                "encode": {
                    "description": "Field references for this series",
                    "properties": {
                        "x": {
                            "description": "Hash of xRef (computed)",
                            "type": "string"
                        },
                        "xRef": {
                            "$ref": "#/$defs/PivotReference",
                            "description": "X axis field reference"
                        },
                        "y": {
                            "description": "Hash of yRef (computed)",
                            "type": "string"
                        },
                        "yRef": {
                            "$ref": "#/$defs/PivotReference",
                            "description": "Y axis field reference"
                        }
                    },
                    "required": ["yRef", "xRef"],
                    "type": "object"
                },
                "hidden": {
                    "description": "Hide this series from the chart",
                    "type": "boolean"
                },
                "isFilteredOut": {
                    "description": "Whether this series is currently filtered out",
                    "type": "boolean"
                },
                "label": {
                    "description": "Data label configuration",
                    "properties": {
                        "color": {
                            "description": "Custom data label color (hex code)",
                            "type": "string"
                        },
                        "position": {
                            "description": "Position of data labels",
                            "enum": [
                                "left",
                                "top",
                                "right",
                                "bottom",
                                "inside"
                            ],
                            "type": "string"
                        },
                        "show": {
                            "description": "Show data labels on points",
                            "type": "boolean"
                        },
                        "showLabel": {
                            "description": "Show the legend/pivot name",
                            "type": "boolean"
                        },
                        "showOverlappingLabels": {
                            "description": "Show labels even when they overlap",
                            "type": "boolean"
                        },
                        "showSeriesName": {
                            "description": "Show the metric field name",
                            "type": "boolean"
                        },
                        "showValue": {
                            "description": "Show the metric value",
                            "type": "boolean"
                        }
                    },
                    "type": "object"
                },
                "markLine": {
                    "$ref": "#/$defs/MarkLine",
                    "description": "Reference line configuration"
                },
                "name": {
                    "description": "Display name for the series",
                    "type": "string"
                },
                "showSymbol": {
                    "description": "Show symbols/markers on data points",
                    "type": "boolean"
                },
                "smooth": {
                    "description": "Use smooth curves for line/area charts",
                    "type": "boolean"
                },
                "stack": {
                    "description": "Stack group name (series with same stack name are stacked)",
                    "type": "string"
                },
                "stackLabel": {
                    "description": "Stack total label configuration",
                    "properties": {
                        "show": {
                            "description": "Show stack total labels",
                            "type": "boolean"
                        }
                    },
                    "type": "object"
                },
                "type": {
                    "$ref": "#/$defs/CartesianSeriesType",
                    "description": "Series visualization type"
                },
                "yAxisIndex": {
                    "description": "Index of Y axis to use (for dual Y axis charts)",
                    "format": "double",
                    "type": "number"
                }
            },
            "required": ["type", "encode"],
            "type": "object"
        },
        "SeriesMetadata": {
            "properties": {
                "color": {
                    "description": "Color for the series",
                    "type": "string"
                }
            },
            "required": ["color"],
            "type": "object"
        },
        "SortByDirection": {
            "enum": ["ASC", "DESC"],
            "type": "string"
        },
        "SortField": {
            "properties": {
                "descending": {
                    "description": "Sort in descending order",
                    "type": "boolean"
                },
                "fieldId": {
                    "description": "Field ID to sort by",
                    "type": "string"
                },
                "nullsFirst": {
                    "description": "Sort null values first",
                    "type": "boolean"
                },
                "pivotValues": {
                    "description": "Pins the row-sort anchor to a specific pivot column. Ignored for non-pivoted results.",
                    "items": {
                        "$ref": "#/$defs/PivotSortAnchor"
                    },
                    "type": "array"
                }
            },
            "required": ["descending", "fieldId"],
            "type": "object"
        },
        "SpaceMemberRole": {
            "enum": ["viewer", "editor", "admin"],
            "type": "string"
        },
        "SqlChartAsCode": {
            "additionalProperties": false,
            "description": "A SQL chart: runs the sql query and visualizes its results",
            "properties": {
                "access": {
                    "$ref": "#/$defs/ContentAsCodeDirectAccess",
                    "description": "Direct user/group grants. Omission leaves the existing policy unchanged on upload."
                },
                "chartKind": {
                    "$ref": "#/$defs/ChartKind"
                },
                "config": {
                    "$ref": "#/$defs/AllVizChartConfig"
                },
                "connection": {
                    "type": "string"
                },
                "contentType": {
                    "$ref": "#/$defs/ContentAsCodeType.SQL_CHART"
                },
                "description": {
                    "type": ["string", "null"]
                },
                "downloadedAt": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "format": "double",
                    "type": "number"
                },
                "name": {
                    "type": "string"
                },
                "slug": {
                    "type": "string"
                },
                "spaceSlug": {
                    "type": "string"
                },
                "sql": {
                    "type": "string"
                },
                "updatedAt": {
                    "format": "date-time",
                    "type": "string"
                },
                "version": {
                    "const": 1,
                    "format": "double",
                    "type": "number"
                }
            },
            "required": [
                "config",
                "limit",
                "description",
                "name",
                "slug",
                "sql",
                "chartKind",
                "spaceSlug",
                "version"
            ],
            "type": "object"
        },
        "SqlTableCalculation": {
            "allOf": [
                {
                    "$ref": "#/$defs/TableCalculationBase"
                },
                {
                    "properties": {
                        "sql": {
                            "description": "SQL expression for the calculation (can reference fields with ${table.field})",
                            "type": "string"
                        }
                    },
                    "required": ["sql"],
                    "type": "object"
                }
            ]
        },
        "StackType": {
            "enum": ["none", "stack", "stack100"],
            "type": "string"
        },
        "TableCalculation": {
            "anyOf": [
                {
                    "$ref": "#/$defs/SqlTableCalculation"
                },
                {
                    "$ref": "#/$defs/TemplateTableCalculation"
                },
                {
                    "$ref": "#/$defs/FormulaTableCalculation"
                }
            ]
        },
        "TableCalculationBase": {
            "properties": {
                "displayName": {
                    "description": "Display name shown in the UI",
                    "type": "string"
                },
                "format": {
                    "$ref": "#/$defs/CustomFormat",
                    "description": "Formatting options for the calculation"
                },
                "index": {
                    "description": "Display order index",
                    "format": "double",
                    "type": "number"
                },
                "name": {
                    "description": "Internal name of the table calculation",
                    "type": "string"
                },
                "totalMode": {
                    "$ref": "#/$defs/TableCalculationTotalMode",
                    "description": "How column totals are computed for this calculation"
                },
                "type": {
                    "$ref": "#/$defs/TableCalculationType",
                    "description": "Data type of the calculation result"
                }
            },
            "required": ["displayName", "name"],
            "type": "object"
        },
        "TableCalculationTemplate": {
            "anyOf": [
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": "string"
                        },
                        "orderBy": {
                            "description": "Fields to order by for window functions",
                            "items": {
                                "properties": {
                                    "fieldId": {
                                        "type": "string"
                                    },
                                    "order": {
                                        "enum": ["asc", "desc", null],
                                        "type": ["string", "null"]
                                    }
                                },
                                "required": ["order", "fieldId"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "partitionBy": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.DIFFERENCE_FROM_PREVIOUS",
                            "description": "Type of template calculation"
                        }
                    },
                    "required": ["orderBy", "fieldId", "type"],
                    "type": "object"
                },
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": "string"
                        },
                        "orderBy": {
                            "description": "Fields to order by for window functions",
                            "items": {
                                "properties": {
                                    "fieldId": {
                                        "type": "string"
                                    },
                                    "order": {
                                        "enum": ["asc", "desc", null],
                                        "type": ["string", "null"]
                                    }
                                },
                                "required": ["order", "fieldId"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "partitionBy": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.PERCENT_CHANGE_FROM_PREVIOUS",
                            "description": "Type of template calculation"
                        }
                    },
                    "required": ["orderBy", "fieldId", "type"],
                    "type": "object"
                },
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": "string"
                        },
                        "orderBy": {
                            "description": "Fields to order by for window functions",
                            "items": {
                                "properties": {
                                    "fieldId": {
                                        "type": "string"
                                    },
                                    "order": {
                                        "enum": ["asc", "desc", null],
                                        "type": ["string", "null"]
                                    }
                                },
                                "required": ["order", "fieldId"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "partitionBy": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.PERCENT_OF_PREVIOUS_VALUE",
                            "description": "Type of template calculation"
                        }
                    },
                    "required": ["orderBy", "fieldId", "type"],
                    "type": "object"
                },
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": "string"
                        },
                        "partitionBy": {
                            "description": "Fields to partition by",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.PERCENT_OF_COLUMN_TOTAL",
                            "description": "Type of template calculation"
                        }
                    },
                    "required": ["fieldId", "type"],
                    "type": "object"
                },
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": "string"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.RANK_IN_COLUMN",
                            "description": "Type of template calculation"
                        }
                    },
                    "required": ["fieldId", "type"],
                    "type": "object"
                },
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": "string"
                        },
                        "orderBy": {
                            "description": "Fields to order by for the running total",
                            "items": {
                                "properties": {
                                    "fieldId": {
                                        "type": "string"
                                    },
                                    "order": {
                                        "enum": ["asc", "desc", null],
                                        "type": ["string", "null"]
                                    }
                                },
                                "required": ["order", "fieldId"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.RUNNING_TOTAL",
                            "description": "Type of template calculation"
                        }
                    },
                    "required": ["fieldId", "type"],
                    "type": "object"
                },
                {
                    "properties": {
                        "fieldId": {
                            "description": "Field ID to apply the template to",
                            "type": ["string", "null"]
                        },
                        "frame": {
                            "$ref": "#/$defs/FrameClause",
                            "description": "Frame clause for window functions"
                        },
                        "orderBy": {
                            "description": "Fields to order by for window functions",
                            "items": {
                                "properties": {
                                    "fieldId": {
                                        "type": "string"
                                    },
                                    "order": {
                                        "enum": ["asc", "desc", null],
                                        "type": ["string", "null"]
                                    }
                                },
                                "required": ["order", "fieldId"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "partitionBy": {
                            "description": "Fields to partition by for window functions",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "type": {
                            "$ref": "#/$defs/TableCalculationTemplateType.WINDOW_FUNCTION",
                            "description": "Type of template calculation"
                        },
                        "windowFunction": {
                            "$ref": "#/$defs/WindowFunctionType",
                            "description": "Window function type"
                        }
                    },
                    "required": [
                        "partitionBy",
                        "orderBy",
                        "fieldId",
                        "windowFunction",
                        "type"
                    ],
                    "type": "object"
                }
            ]
        },
        "TableCalculationTemplateType.DIFFERENCE_FROM_PREVIOUS": {
            "enum": ["difference_from_previous"],
            "type": "string"
        },
        "TableCalculationTemplateType.PERCENT_CHANGE_FROM_PREVIOUS": {
            "enum": ["percent_change_from_previous"],
            "type": "string"
        },
        "TableCalculationTemplateType.PERCENT_OF_COLUMN_TOTAL": {
            "enum": ["percent_of_column_total"],
            "type": "string"
        },
        "TableCalculationTemplateType.PERCENT_OF_PREVIOUS_VALUE": {
            "enum": ["percent_of_previous_value"],
            "type": "string"
        },
        "TableCalculationTemplateType.RANK_IN_COLUMN": {
            "enum": ["rank_in_column"],
            "type": "string"
        },
        "TableCalculationTemplateType.RUNNING_TOTAL": {
            "enum": ["running_total"],
            "type": "string"
        },
        "TableCalculationTemplateType.WINDOW_FUNCTION": {
            "enum": ["window_function"],
            "type": "string"
        },
        "TableCalculationTotalMode": {
            "enum": ["formula", "sum_of_rows", "none"],
            "type": "string"
        },
        "TableCalculationType": {
            "enum": ["number", "string", "date", "timestamp", "boolean"],
            "type": "string"
        },
        "TableChart": {
            "properties": {
                "columns": {
                    "$ref": "#/$defs/Record_string.ColumnProperties_",
                    "description": "Column-specific configuration"
                },
                "conditionalFormattings": {
                    "description": "Conditional formatting rules",
                    "items": {
                        "$ref": "#/$defs/ConditionalFormattingConfig"
                    },
                    "type": "array"
                },
                "hideRowNumbers": {
                    "description": "Hide row number column",
                    "type": "boolean"
                },
                "metricsAsRows": {
                    "description": "Display metrics as rows instead of columns",
                    "type": "boolean"
                },
                "rowLimit": {
                    "$ref": "#/$defs/RowLimit",
                    "description": "Limit displayed rows to first/last N"
                },
                "showColumnCalculation": {
                    "description": "Show column totals/calculations",
                    "type": "boolean"
                },
                "showResultsTotal": {
                    "description": "Show total results count",
                    "type": "boolean"
                },
                "showRowCalculation": {
                    "description": "Show row totals/calculations",
                    "type": "boolean"
                },
                "showRowGrouping": {
                    "description": "Visually deduplicate repeated row-index dimension values across consecutive\nrows without showing aggregate subtotal rows. When `showSubtotals` is true,\ngrouping is implicitly active and this flag is ignored. Defaults to false.",
                    "type": "boolean"
                },
                "showSubtotals": {
                    "description": "Show subtotal rows",
                    "type": "boolean"
                },
                "showSubtotalsExpanded": {
                    "description": "Default subtotal rows to expanded (vs. collapsed). Only meaningful when showSubtotals is true.",
                    "type": "boolean"
                },
                "showTableNames": {
                    "description": "Show table names in column headers",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "TableChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/TableChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.TABLE",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "TemplateTableCalculation": {
            "allOf": [
                {
                    "$ref": "#/$defs/TableCalculationBase"
                },
                {
                    "properties": {
                        "template": {
                            "$ref": "#/$defs/TableCalculationTemplate",
                            "description": "Template-based calculation (alternative to sql)"
                        }
                    },
                    "required": ["template"],
                    "type": "object"
                }
            ]
        },
        "TimeFrames": {
            "enum": [
                "RAW",
                "YEAR",
                "QUARTER",
                "MONTH",
                "WEEK",
                "DAY",
                "HOUR",
                "MINUTE",
                "SECOND",
                "MILLISECOND",
                "DAY_OF_WEEK_INDEX",
                "DAY_OF_MONTH_NUM",
                "DAY_OF_YEAR_NUM",
                "WEEK_NUM",
                "MONTH_NUM",
                "QUARTER_NUM",
                "YEAR_NUM",
                "DAY_OF_WEEK_NAME",
                "MONTH_NAME",
                "QUARTER_NAME",
                "HOUR_OF_DAY_NUM",
                "MINUTE_OF_HOUR_NUM"
            ],
            "type": "string"
        },
        "TooltipSortBy": {
            "enum": [
                "default",
                "alphabetical",
                "value_ascending",
                "value_descending"
            ],
            "type": "string"
        },
        "TreemapChart": {
            "properties": {
                "colorMetricId": {
                    "description": "Field ID for node color value",
                    "type": "string"
                },
                "endColor": {
                    "description": "End color for color gradient (hex code)",
                    "type": "string"
                },
                "endColorThreshold": {
                    "description": "Value threshold for end color",
                    "format": "double",
                    "type": "number"
                },
                "groupFieldIds": {
                    "description": "Field IDs for hierarchical grouping",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "leafDepth": {
                    "description": "Depth of leaf nodes to display",
                    "format": "double",
                    "type": "number"
                },
                "sizeMetricId": {
                    "description": "Field ID for node size",
                    "type": "string"
                },
                "startColor": {
                    "description": "Start color for color gradient (hex code)",
                    "type": "string"
                },
                "startColorThreshold": {
                    "description": "Value threshold for start color",
                    "format": "double",
                    "type": "number"
                },
                "useDynamicColors": {
                    "description": "Use dynamic color scaling based on values",
                    "type": "boolean"
                },
                "visibleMin": {
                    "description": "Minimum size for visible nodes",
                    "format": "double",
                    "type": "number"
                }
            },
            "type": "object"
        },
        "TreemapChartConfig": {
            "properties": {
                "config": {
                    "$ref": "#/$defs/TreemapChart",
                    "description": "Chart-type-specific configuration"
                },
                "type": {
                    "$ref": "#/$defs/ChartType.TREEMAP",
                    "description": "Type of chart visualization"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "ValueLabelPositionOptions": {
            "enum": ["hidden", "top", "bottom", "left", "right", "inside"],
            "type": "string"
        },
        "VizAggregationOptions": {
            "enum": ["sum", "count", "avg", "min", "max", "any"],
            "type": "string"
        },
        "VizBarChartConfig": {
            "allOf": [
                {
                    "$ref": "#/$defs/VizBaseConfig"
                },
                {
                    "properties": {
                        "display": {
                            "$ref": "#/$defs/CartesianChartDisplay"
                        },
                        "fieldConfig": {
                            "$ref": "#/$defs/PivotChartLayout"
                        },
                        "type": {
                            "$ref": "#/$defs/ChartKind.VERTICAL_BAR"
                        }
                    },
                    "required": ["type"],
                    "type": "object"
                }
            ]
        },
        "VizBaseConfig": {
            "properties": {
                "metadata": {
                    "properties": {
                        "version": {
                            "format": "double",
                            "type": "number"
                        }
                    },
                    "required": ["version"],
                    "type": "object"
                },
                "type": {
                    "$ref": "#/$defs/ChartKind"
                }
            },
            "required": ["type", "metadata"],
            "type": "object"
        },
        "VizBigNumberConditionalOperator": {
            "anyOf": [
                {
                    "$ref": "#/$defs/FilterOperator.EQUALS"
                },
                {
                    "$ref": "#/$defs/FilterOperator.NOT_EQUALS"
                },
                {
                    "$ref": "#/$defs/FilterOperator.LESS_THAN"
                },
                {
                    "$ref": "#/$defs/FilterOperator.LESS_THAN_OR_EQUAL"
                },
                {
                    "$ref": "#/$defs/FilterOperator.GREATER_THAN"
                },
                {
                    "$ref": "#/$defs/FilterOperator.GREATER_THAN_OR_EQUAL"
                }
            ],
            "description": "Operators a big number threshold can be expressed with."
        },
        "VizBigNumberConditionalRule": {
            "properties": {
                "color": {
                    "description": "Applied in the light colour scheme, and in dark when darkColor is unset.",
                    "type": "string"
                },
                "darkColor": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/$defs/VizBigNumberConditionalOperator"
                },
                "value": {
                    "format": "double",
                    "type": "number"
                }
            },
            "required": ["color", "value", "operator"],
            "type": "object"
        },
        "VizBigNumberConfig": {
            "allOf": [
                {
                    "$ref": "#/$defs/VizBaseConfig"
                },
                {
                    "properties": {
                        "display": {
                            "$ref": "#/$defs/VizBigNumberDisplay"
                        },
                        "fieldConfig": {
                            "$ref": "#/$defs/PivotChartLayout",
                            "description": "Big numbers aggregate every row, so `x` is always undefined and `y`\nholds the value field followed by the optional comparison field."
                        },
                        "type": {
                            "$ref": "#/$defs/ChartKind.BIG_NUMBER"
                        }
                    },
                    "required": ["type"],
                    "type": "object"
                }
            ]
        },
        "VizBigNumberDisplay": {
            "properties": {
                "comparisonFormat": {
                    "$ref": "#/$defs/ComparisonFormatTypes"
                },
                "comparisonLabel": {
                    "type": "string"
                },
                "conditionalFormatting": {
                    "description": "Colours the value; the first matching rule wins.",
                    "items": {
                        "$ref": "#/$defs/VizBigNumberConditionalRule"
                    },
                    "type": "array"
                },
                "flipColors": {
                    "description": "Colours an increase red and a decrease green.",
                    "type": "boolean"
                },
                "label": {
                    "description": "Custom label rendered under the value. Falls back to the field name.",
                    "type": "string"
                },
                "showComparison": {
                    "description": "Compares the value against the second selected field.",
                    "type": "boolean"
                },
                "showLabel": {
                    "type": "boolean"
                },
                "style": {
                    "$ref": "#/$defs/CompactOrAlias",
                    "description": "Compact notation applied to the value (K/M/B/T)."
                }
            },
            "type": "object"
        },
        "VizColumnConfig": {
            "properties": {
                "aggregation": {
                    "$ref": "#/$defs/VizAggregationOptions"
                },
                "barConfig": {
                    "properties": {
                        "color": {
                            "type": "string"
                        },
                        "max": {
                            "format": "double",
                            "type": "number"
                        },
                        "min": {
                            "format": "double",
                            "type": "number"
                        }
                    },
                    "type": "object"
                },
                "displayStyle": {
                    "enum": ["text", "bar"],
                    "type": "string"
                },
                "frozen": {
                    "type": "boolean"
                },
                "label": {
                    "type": "string"
                },
                "order": {
                    "format": "double",
                    "type": "number"
                },
                "reference": {
                    "type": "string"
                },
                "visible": {
                    "type": "boolean"
                }
            },
            "required": ["frozen", "label", "reference", "visible"],
            "type": "object"
        },
        "VizColumnsConfig": {
            "additionalProperties": {
                "$ref": "#/$defs/VizColumnConfig"
            },
            "properties": {},
            "type": "object"
        },
        "VizIndexType": {
            "enum": ["time", "category"],
            "type": "string"
        },
        "VizLineChartConfig": {
            "allOf": [
                {
                    "$ref": "#/$defs/VizBaseConfig"
                },
                {
                    "properties": {
                        "display": {
                            "$ref": "#/$defs/CartesianChartDisplay"
                        },
                        "fieldConfig": {
                            "$ref": "#/$defs/PivotChartLayout"
                        },
                        "type": {
                            "$ref": "#/$defs/ChartKind.LINE"
                        }
                    },
                    "required": ["type"],
                    "type": "object"
                }
            ]
        },
        "VizPieChartConfig": {
            "allOf": [
                {
                    "$ref": "#/$defs/VizBaseConfig"
                },
                {
                    "properties": {
                        "display": {
                            "$ref": "#/$defs/VizPieChartDisplay"
                        },
                        "fieldConfig": {
                            "$ref": "#/$defs/PivotChartLayout"
                        },
                        "type": {
                            "$ref": "#/$defs/ChartKind.PIE"
                        }
                    },
                    "required": ["type"],
                    "type": "object"
                }
            ]
        },
        "VizPieChartDisplay": {
            "properties": {
                "isDonut": {
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "VizSortBy": {
            "properties": {
                "direction": {
                    "$ref": "#/$defs/SortByDirection"
                },
                "nullsFirst": {
                    "type": "boolean"
                },
                "pivotValues": {
                    "description": "Pins the row-sort anchor to a specific pivot column.",
                    "items": {
                        "$ref": "#/$defs/PivotSortAnchor"
                    },
                    "type": "array"
                },
                "reference": {
                    "type": "string"
                }
            },
            "required": ["direction", "reference"],
            "type": "object"
        },
        "VizTableConfig": {
            "allOf": [
                {
                    "$ref": "#/$defs/VizBaseConfig"
                },
                {
                    "properties": {
                        "columns": {
                            "$ref": "#/$defs/VizColumnsConfig"
                        },
                        "display": {
                            "$ref": "#/$defs/VizTableDisplay"
                        },
                        "type": {
                            "$ref": "#/$defs/ChartKind.TABLE"
                        }
                    },
                    "required": ["columns", "type"],
                    "type": "object"
                }
            ]
        },
        "VizTableDisplay": {
            "properties": {},
            "type": "object"
        },
        "WindowFunctionType": {
            "enum": [
                "row_number",
                "percent_rank",
                "cume_dist",
                "rank",
                "sum",
                "avg",
                "count",
                "min",
                "max"
            ],
            "type": "string"
        },
        "XAxis": {
            "allOf": [
                {
                    "$ref": "#/$defs/Axis"
                },
                {
                    "properties": {
                        "dataZoomAnchor": {
                            "description": "Where the initial data-zoom window anchors when data zoom is enabled",
                            "enum": ["start", "end"],
                            "type": "string"
                        },
                        "dataZoomItemCount": {
                            "description": "Number of items visible at once in the data-zoom window",
                            "format": "double",
                            "type": "number"
                        },
                        "enableDataZoom": {
                            "description": "Enable data zoom slider for this axis",
                            "type": "boolean"
                        },
                        "sortType": {
                            "$ref": "#/$defs/XAxisSortType",
                            "description": "How to sort the X axis"
                        },
                        "treatAsCategory": {
                            "description": "Render a numeric X axis as discrete categories instead of a continuous scale",
                            "type": "boolean"
                        }
                    },
                    "type": "object"
                }
            ]
        },
        "XAxisSortType": {
            "enum": ["default", "category", "bar_totals"],
            "type": "string"
        }
    },
    "$id": "https://schemas.lightdash.com/lightdash/chart-as-code.json",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "description": "Schema for defining Lightdash charts (semantic layer charts and SQL charts) in YAML format for version control",
    "else": {
        "$ref": "#/$defs/ChartAsCode"
    },
    "if": {
        "anyOf": [
            {
                "properties": {
                    "contentType": {
                        "const": "sql_chart"
                    }
                },
                "required": ["contentType"]
            },
            {
                "not": {
                    "anyOf": [
                        {
                            "required": ["contentType"]
                        },
                        {
                            "required": ["tableName"]
                        }
                    ]
                },
                "required": ["sql"]
            }
        ]
    },
    "then": {
        "$ref": "#/$defs/SqlChartAsCode"
    },
    "title": "Lightdash Chart as Code",
    "type": "object"
}
